// Load configuration ONCE - global scope to prevent multiple executions
if (!window.magtecAppSettings) {
    console.log('Loading appsettings.json...');

    function loadAppSettings() {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'appsettings.json', false); // synchronous request
        xhr.send();

        if (xhr.status === 200) {
            try {
                var result = JSON.parse(xhr.responseText);
                console.log('Successfully loaded appsettings.json');
                return result;
            } catch (e) {
                console.error('Error parsing appsettings.json:', e);
                return null;
            }
        } else {
            console.error('Failed to load appsettings.json:', xhr.status);
            return null;
        }
    }

    // Load and cache the configuration globally
    window.magtecAppSettings = loadAppSettings();
} else {
    console.log('appsettings.json already loaded, using cached version');
}

// Get the base path from cached settings
var appSettings = window.magtecAppSettings;
var basePath = appSettings ? appSettings.basePath : 'https://localhost:7265/'; // fallback if needed

(function () {
    'use strict';



    angular.module('ainapp', ['ui.router', 'ui.bootstrap', 'LocalStorageModule', 'ngLoader', 'kendo.directives', 'angular.filter', 'textAngular', 'directive.contextMenu'])

        .value('app.config', {
            basePath: basePath
        })

        .config(['$stateProvider', '$urlRouterProvider', '$locationProvider',
        function ($stateProvider, $urlRouterProvider, $locationProvider) {

                $urlRouterProvider.otherwise('login');
                $stateProvider

                    .state("login", {
                        url: "/login",
                        templateUrl: "templates/login.tpl.html",
                        controller: "LoginController",
                    })


                    .state("init", {
                        abstract: true,
                        url: "/init",
                        templateUrl: "templates/init.tpl.html",
                        controller: "InitController",
                    })

                    .state("changePassword", {
                        parent: "init",
                        url: "/changePassword",
                        templateUrl: "templates/changePassword.tpl.html",
                    })

                    .state("home", {
                        parent: "init",
                        url: "/home",
                        templateUrl: "templates/home.tpl.html",
                        controller: "HomeController",
                    })

                    .state("favMenu", {
                        parent: "init",
                        url: "/favMenu",
                        templateUrl: "templates/favMenu.tpl.html",
                        controller: "favMenuController",
                    })


                    //////////////////////////// Dashboards ////////////////////////////

                    .state("salesDash", {
                        parent: "init",
                        url: "/salesDash",
                        templateUrl: "templates/dashboard/salesDash.tpl.html",
                        controller: "salesDashController",
                    })


                    .state("purchaseDash", {
                        parent: "init",
                        url: "/purchaseDash",
                        templateUrl: "templates/dashboard/purchaseDash.tpl.html",
                        controller: "purchaseDashController",
                    })

                    .state("financialDash", {
                        parent: "init",
                        url: "/financialDash",
                        templateUrl: "templates/dashboard/financialDash.tpl.html",
                        controller: "financialDashController",
                    })

                    .state("realestateDash", {
                        parent: "init",
                        url: "/realestateDash",
                        templateUrl: "templates/dashboard/realestateDash.tpl.html",
                        controller: "realestateDashController",
                    })

                    .state("hrDash", {
                        parent: "init",
                        url: "/hrDash",
                        templateUrl: "templates/dashboard/hrDash.tpl.html",
                        controller: "hrDashController",
                    })

                    .state("brokerDash", {
                        parent: "init",
                        url: "/brokerDash",
                        templateUrl: "templates/dashboard/brokerDash.tpl.html",
                        controller: "brokerDashController",
                    })

                    .state("employeeDash", {
                        parent: "init",
                        url: "/employeeDash",
                        templateUrl: "templates/dashboard/employeeDash.tpl.html",
                        controller: "employeeDashController",
                    })
                    .state("approvalDash", {
                        parent: "init",
                        url: "/approvalDash",
                        templateUrl: "templates/dashboard/approvalDash.tpl.html",
                        controller: "approvalDashController",
                    })
                    .state("pendingSalesDash", {
                        parent: "init",
                        url: "/pendingSalesDash",
                        templateUrl: "templates/dashboard/pendingSalesDash.tpl.html",
                        controller: "pendingSalesDashController",
                    })
                    .state("pendingPurchaseDash", {
                        parent: "init",
                        url: "/pendingPurchaseDash",
                        templateUrl: "templates/dashboard/pendingPurchaseDash.tpl.html",
                        controller: "pendingPurchaseDashController",
                    })


                    //////////////////////////// End Dashboards ////////////////////////////

                    ////////////////////////////  masters  ///////////////////////////

                    .state("AccountType", {
                        parent: "init",
                        url: "/AccountType",
                        templateUrl: "templates/masters/AccountType.tpl.html",
                        controller: "AccountTypeController",
                    })

                    .state("AccountMaster", {
                        url: "/AccountMaster",
                        parent: "init",
                        templateUrl: "Templates/masters/AccountMaster.tpl.html",
                        controller: "AccountMasterController",
                    })

                    .state("AccountCostCenters", {
                        url: "/AccountCostCenters/:AccountMasterId",
                        parent: "init",
                        templateUrl: "Templates/masters/AccountCostCenters.tpl.html",
                        controller: "AccountCostCentersController",
                    })


                    .state("CostCenterTree", {
                        url: "/CostCenterTree",
                        parent: "init",
                        templateUrl: "Templates/masters/CostCenterTree.tpl.html",
                        controller: "CostCenterTreeController",
                    })

                    .state("CostCenter", {
                        url: "/CostCenter/:costId/:costName",
                        parent: "init",
                        templateUrl: "Templates/masters/CostCenter.tpl.html",
                        controller: "CostCenterController",
                    })

                    //////////////////////// inventory ////////////////////

                    .state("productParentCategory", {
                        url: "/productParentCategory",
                        parent: "init",
                        templateUrl: "Templates/inventory/productParentCategory.tpl.html",
                        controller: "productParentCategoryController",
                    })

                    .state("productCategory", {
                        url: "/productCategory",
                        parent: "init",
                        templateUrl: "Templates/inventory/productCategory.tpl.html",
                        controller: "productCategoryController",
                    })

                    .state("productSubCategory", {
                        url: "/productSubCategory",
                        parent: "init",
                        templateUrl: "Templates/inventory/productSubCategory.tpl.html",
                        controller: "productSubCategoryController",
                    })

                    .state("products", {
                        url: "/products",
                        parent: "init",
                        templateUrl: "Templates/inventory/products.tpl.html",
                        controller: "productsController",
                    })

                    .state("editProduct", {
                        url: "/editProduct/:ItemId",
                        parent: "init",
                        templateUrl: "Templates/inventory/products.tpl.html",
                        controller: "productsController",
                    })

                    .state("productList", {
                        url: "/productList",
                        parent: "init",
                        templateUrl: "Templates/inventory/productList.tpl.html",
                        controller: "productListController",
                    })

                    .state("productUpdate", {
                        url: "/productUpdate",
                        parent: "init",
                        templateUrl: "Templates/inventory/productUpdate.tpl.html",
                        controller: "productUpdateController",
                    })

                    .state("priceChart", {
                        url: "/priceChart",
                        parent: "init",
                        templateUrl: "Templates/inventory/priceChart.tpl.html",
                        controller: "priceChartController",
                    })

                    .state("recipe", {
                        parent: "init",
                        url: "/recipe/:productId",
                        templateUrl: "templates/inventory/recipe.tpl.html",
                        controller: "recipeController",
                    })

                    .state("productType", {
                        parent: "init",
                        url: "/productType",
                        templateUrl: "templates/inventory/productType.tpl.html",
                        controller: "productTypeController",
                    })

                    .state("productSize", {
                        parent: "init",
                        url: "/productSize",
                        templateUrl: "templates/inventory/productSize.tpl.html",
                        controller: "productSizeController",
                    })

                    .state("productColor", {
                        parent: "init",
                        url: "/productColor",
                        templateUrl: "templates/inventory/productColor.tpl.html",
                        controller: "productColorController",
                    })

                    .state("assetCategory", {
                        url: "/assetCategory",
                        parent: "init",
                        templateUrl: "Templates/inventory/assetCategory.tpl.html",
                        controller: "assetCategoryController",
                    })

                    .state("assetSubCategory", {
                        url: "/assetSubCategory",
                        parent: "init",
                        templateUrl: "Templates/inventory/assetSubCategory.tpl.html",
                        controller: "assetSubCategoryController",
                    })

                    .state("assets", {
                        url: "/assets",
                        parent: "init",
                        templateUrl: "Templates/inventory/assets.tpl.html",
                        controller: "assetsController",
                    })

                    .state("editAsset", {
                        url: "/editAsset/:ItemId",
                        parent: "init",
                        templateUrl: "Templates/inventory/assets.tpl.html",
                        controller: "assetsController",
                    })


                    .state("AssetList", {
                        url: "/AssetList",
                        parent: "init",
                        templateUrl: "Templates/inventory/AssetList.tpl.html",
                        controller: "AssetListController",
                    })

                    .state("serviceCategory", {
                        url: "/serviceCategory",
                        parent: "init",
                        templateUrl: "Templates/inventory/serviceCategory.tpl.html",
                        controller: "serviceCategoryController",
                    })

                    .state("serviceSubCategory", {
                        url: "/serviceSubCategory",
                        parent: "init",
                        templateUrl: "Templates/inventory/serviceSubCategory.tpl.html",
                        controller: "serviceSubCategoryController",
                    })

                    .state("services", {
                        url: "/services",
                        parent: "init",
                        templateUrl: "Templates/inventory/services.tpl.html",
                        controller: "servicesController",
                    })

                    .state("editService", {
                        url: "/editService/:ItemId",
                        parent: "init",
                        templateUrl: "Templates/inventory/services.tpl.html",
                        controller: "servicesController",
                    })

                    .state("ServiceList", {
                        url: "/ServiceList",
                        parent: "init",
                        templateUrl: "Templates/inventory/ServiceList.tpl.html",
                        controller: "ServiceListController",
                    })

                    .state("substituteProduct", {
                        url: "/substituteProduct",
                        parent: "init",
                        templateUrl: "Templates/inventory/substituteProduct.tpl.html",
                        controller: "substituteProductController",
                    })

                    //////////////////////// inventory ////////////////////

                    .state("Designation", {
                        parent: "init",
                        url: "/Designation",
                        templateUrl: "templates/masters/Designation.tpl.html",
                        controller: "DesignationController",
                    })

                    .state("Department", {
                        parent: "init",
                        url: "/Department",
                        templateUrl: "templates/masters/Department.tpl.html",
                        controller: "DepartmentController",
                    })

                    .state("Country", {
                        parent: "init",
                        url: "/Country",
                        templateUrl: "templates/masters/Country.tpl.html",
                        controller: "CountryController",
                    })

                    .state("VAT", {
                        url: "/VAT",
                        parent: "init",
                        templateUrl: "Templates/masters/VAT.tpl.html",
                        controller: "VATController",
                    })

                    .state("Unit", {
                        url: "/Unit",
                        parent: "init",
                        templateUrl: "Templates/masters/Unit.tpl.html",
                        controller: "UnitController",
                    })

                    .state("UnitConvertion", {
                        url: "/UnitConvertion",
                        parent: "init",
                        templateUrl: "Templates/masters/UnitConvertion.tpl.html",
                        controller: "UnitConvertionController",
                    })

                    .state("UnitConvertionProduct", {
                        url: "/UnitConvertionProduct/:ProductId",
                        parent: "init",
                        templateUrl: "Templates/masters/UnitConvertion.tpl.html",
                        controller: "UnitConvertionController",
                    })

                    .state("City", {
                        url: "/City",
                        parent: "init",
                        templateUrl: "Templates/masters/City.tpl.html",
                        controller: "CityController",
                    })

                    .state("Currency", {
                        url: "/Currency",
                        parent: "init",
                        templateUrl: "Templates/masters/Currency.tpl.html",
                        controller: "CurrencyController",
                    })

                    .state("CurrencyConvertion", {
                        url: "/CurrencyConvertion",
                        parent: "init",
                        templateUrl: "Templates/masters/CurrencyConvertion.tpl.html",
                        controller: "CurrencyConvertionController",
                    })

                    .state("Cusian", {
                        parent: "init",
                        url: "/Cusian",
                        templateUrl: "templates/masters/Cusian.tpl.html",
                        controller: "CusianController",
                    })

                    .state("employee", {
                        url: "/employee",
                        parent: "init",
                        templateUrl: "Templates/masters/employee.tpl.html",
                        controller: "employeeController",
                    })

                    .state("employeeCard", {
                        url: "/employeeCard",
                        parent: "init",
                        templateUrl: "Templates/hr/employeeCard.tpl.html",
                        controller: "employeeCardController",
                    })

                    .state("addEmployee", {
                        url: "/addEmployee",
                        parent: "init",
                        templateUrl: "Templates/masters/addEmployee.tpl.html",
                        controller: "addEmployeeController",
                    })
                    .state("editEmployee", {
                        url: "/editEmployee/:EmployeeId",
                        parent: "init",
                        templateUrl: "Templates/masters/addEmployee.tpl.html",
                        controller: "addEmployeeController",
                    })

                    .state("Customers", {
                        parent: "init",
                        url: "/Customers",
                        templateUrl: "templates/masters/Customers.tpl.html",
                        controller: "CustomersController",
                    })

                    .state("addCustomer", {
                        parent: "init",
                        url: "/addCustomer",
                        templateUrl: "templates/masters/addCustomer.tpl.html",
                        controller: "addCustomerController",
                    })

                    .state("editCustomer", {
                        url: "/editCustomer/:AccountId",
                        parent: "init",
                        templateUrl: "templates/masters/addCustomer.tpl.html",
                        controller: "addCustomerController",
                    })

                    .state("Vendors", {
                        parent: "init",
                        url: "/Vendors",
                        templateUrl: "templates/masters/Vendors.tpl.html",
                        controller: "VendorsController",
                    })

                    .state("addVendor", {
                        parent: "init",
                        url: "/addVendor",
                        templateUrl: "templates/masters/addVendor.tpl.html",
                        controller: "addVendorController",
                    })

                    .state("editVendor", {
                        url: "/editVendor/:AccountId",
                        parent: "init",
                        templateUrl: "templates/masters/addVendor.tpl.html",
                        controller: "addVendorController",
                    })

                    .state("Expenses", {
                        parent: "init",
                        url: "/Expenses",
                        templateUrl: "templates/masters/Expenses.tpl.html",
                        controller: "ExpensesController",
                    })



                    .state("branch", {
                        parent: "init",
                        url: "/branch",
                        templateUrl: "templates/masters/branch.tpl.html",
                        controller: "branchController",
                    })

                    .state("status", {
                        parent: "init",
                        url: "/status",
                        templateUrl: "templates/masters/status.tpl.html",
                        controller: "statusController",
                    })

                   
                    .state("brand", {
                        url: "/brand",
                        parent: "init",
                        templateUrl: "Templates/masters/brand.tpl.html",
                        controller: "brandController",
                    })

                    .state("userRoles", {
                        url: "/userRoles",
                        parent: "init",
                        templateUrl: "Templates/masters/userRoles.tpl.html",
                        controller: "userRolesController",
                    })

                    .state("users", {
                        url: "/users",
                        parent: "init",
                        templateUrl: "Templates/masters/users.tpl.html",
                        controller: "usersController",
                    })

                    .state("master1", {
                        url: "/master1",
                        parent: "init",
                        templateUrl: "Templates/masters/master1.tpl.html",
                        controller: "master1Controller",
                    })
                    .state("master2", {
                        url: "/master2",
                        parent: "init",
                        templateUrl: "Templates/masters/master2.tpl.html",
                        controller: "master2Controller",
                    })
                    .state("master3", {
                        url: "/master3",
                        parent: "init",
                        templateUrl: "Templates/masters/master3.tpl.html",
                        controller: "master3Controller",
                    })
                    .state("master4", {
                        url: "/master4",
                        parent: "init",
                        templateUrl: "Templates/masters/master4.tpl.html",
                        controller: "master4Controller",
                    })
                    .state("master5", {
                        url: "/master5",
                        parent: "init",
                        templateUrl: "Templates/masters/master5.tpl.html",
                        controller: "master5Controller",
                    })
                    .state("master6", {
                        url: "/master6",
                        parent: "init",
                        templateUrl: "Templates/masters/master6.tpl.html",
                        controller: "master6Controller",
                    })
                    .state("master7", {
                        url: "/master7",
                        parent: "init",
                        templateUrl: "Templates/masters/master7.tpl.html",
                        controller: "master7Controller",
                    })
                    .state("master8", {
                        url: "/master8",
                        parent: "init",
                        templateUrl: "Templates/masters/master8.tpl.html",
                        controller: "master8Controller",
                    })

                    .state("bank", {
                        url: "/bank",
                        parent: "init",
                        templateUrl: "Templates/masters/bank.tpl.html",
                        controller: "bankController",
                    })


                    ////////////////////////////  end masters  ///////////////////////////
                    ////////////////////////////  warehouse  ///////////////////////////

                     .state("warehouse", {
                        url: "/warehouse",
                        parent: "init",
                        templateUrl: "Templates/masters/warehouse.tpl.html",
                        controller: "warehouseController",
                    })

                    .state("warehouseAreas", {
                        url: "/warehouseAreas",
                        parent: "init",
                        templateUrl: "Templates/masters/warehouseAreas.tpl.html",
                        controller: "warehouseAreasController",
                    })

                    .state("warehouseRacks", {
                        url: "/warehouseRacks",
                        parent: "init",
                        templateUrl: "Templates/masters/warehouseRacks.tpl.html",
                        controller: "warehouseRacksController",
                    })

                     .state("warehouseShelves", {
                        url: "/warehouseShelves",
                        parent: "init",
                        templateUrl: "Templates/masters/warehouseShelves.tpl.html",
                        controller: "warehouseShelvesController",
                    })

                    .state("warehouseBins", {
                        url: "/warehouseBins",
                        parent: "init",
                        templateUrl: "Templates/masters/warehouseBins.tpl.html",
                        controller: "warehouseBinsController",
                    })

                    .state("warehouseTree", {
                        url: "/warehouseTree",
                        parent: "init",
                        templateUrl: "Templates/masters/warehouseTree.tpl.html",
                        controller: "warehouseTreeController",
                    })

                    ////////////////////////////  end warehouse  ///////////////////////////

                    ////////////////////////////  Uploads  ///////////////////////////




                    .state("CustomerUpload", {
                        url: "/CustomerUpload",
                        parent: "init",
                        templateUrl: "Templates/uploads/CustomerUpload.tpl.html",
                        controller: "CustomerUploadController",
                    })

                    .state("ExpenseUpload", {
                        url: "/ExpenseUpload",
                        parent: "init",
                        templateUrl: "Templates/uploads/CustomerUpload.tpl.html",
                        controller: "CustomerUploadController",
                    })

                    .state("VendorUpload", {
                        url: "/VendorUpload",
                        parent: "init",
                        templateUrl: "Templates/uploads/CustomerUpload.tpl.html",
                        controller: "CustomerUploadController",
                    })

                    .state("AccountUpload", {
                        url: "/AccountUpload",
                        parent: "init",
                        templateUrl: "Templates/uploads/AccountUpload.tpl.html",
                        controller: "AccountUploadController",
                    })

                    .state("productUpload", {
                        url: "/productUpload",
                        parent: "init",
                        templateUrl: "Templates/uploads/productUpload.tpl.html",
                        controller: "productUploadController",
                    })

                    .state("serviceUpload", {
                        url: "/serviceUpload",
                        parent: "init",
                        templateUrl: "Templates/uploads/productUpload.tpl.html",
                        controller: "productUploadController",
                    })

                    .state("assetUpload", {
                        url: "/assetUpload",
                        parent: "init",
                        templateUrl: "Templates/uploads/productUpload.tpl.html",
                        controller: "productUploadController",
                    })

                    .state("BulkCostCenter", {
                        url: "/BulkCostCenter",
                        parent: "init",
                        templateUrl: "Templates/uploads/BulkCostCenter.tpl.html",
                        controller: "BulkCostCenterController",
                    })

                    .state("bulkDeliveryNote", {
                        url: "/bulkDeliveryNote",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkDeliveryNote.tpl.html",
                        controller: "bulkDeliveryNoteController",
                    })

                    .state("bulkSalesOrder", {
                        url: "/bulkSalesOrder",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkSalesOrder.tpl.html",
                        controller: "bulkSalesOrderController",
                    })

                    .state("bulkSalesOrder2", {
                        url: "/bulkSalesOrder2",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkSalesOrder2.tpl.html",
                        controller: "bulkSalesOrder2Controller",
                    })


                    .state("bulkSalesInvocie", {
                        url: "/bulkSalesInvocie",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkSalesInvocie.tpl.html",
                        controller: "bulkSalesInvocieController",
                    })

                    .state("bulkSalesInvocie2", {
                        url: "/bulkSalesInvocie2",
                        parent: "init",
                       templateUrl: "Templates/uploads/bulkSalesInvocie2.tpl.html",
                        controller: "bulkSalesInvocie2Controller",
                    })

                    .state("bulkDirSalesInvocie", {
                        url: "/bulkDirSalesInvocie",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkDirSalesInvocie.tpl.html",
                        controller: "bulkDirSalesInvocieController",
                    })


                  

                    .state("bulkSalesReturn", {
                        url: "/bulkSalesReturn",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkSalesReturn.tpl.html",
                        controller: "bulkSalesReturnController",
                    })

                    .state("bulkPurchaseInvocie", {
                        url: "/bulkPurchaseInvocie",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkPurchaseInvocie.tpl.html",
                        controller: "bulkPurchaseInvocieController",
                    })

                    .state("bulkDirPurchaseInvocie", {
                        url: "/bulkDirPurchaseInvocie",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkDirPurchaseInvocie.tpl.html",
                        controller: "bulkDirPurchaseInvocieController",
                    })

                      .state("bulkCashPayments", {
                        url: "/bulkCashPayments",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkCashPayments.tpl.html",
                        controller: "bulkCashPaymentsController",
                    })

                    .state("bulkCashReceipts", {
                        url: "/bulkCashReceipts",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkCashReceipts.tpl.html",
                        controller: "bulkCashReceiptsController",
                    })

                    .state("bulkEmployee", {
                        url: "/bulkEmployee",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkEmployee.tpl.html",
                        controller: "bulkEmployeeController",
                    })

                    .state("bulkPurchaseEnquiry", {
                        url: "/bulkPurchaseEnquiry",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkPurchaseEnquiry.tpl.html",
                        controller: "bulkPurchaseEnquiryController",
                    })

                    .state("bulkFundPayment", {
                        url: "/bulkFundPayment",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkFundPayment.tpl.html",
                        controller: "bulkFundPaymentController",
                    })

                    .state("bulkFundReceipt", {
                        url: "/bulkFundReceipt",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkFundReceipt.tpl.html",
                        controller: "bulkFundReceiptController",
                    })

                    .state("bulkChequePayment", {
                        url: "/bulkChequePayment",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkChequePayment.tpl.html",
                        controller: "bulkChequePaymentController",
                    })
                    .state("bulkChequeReceipt", {
                        url: "/bulkChequeReceipt",
                        parent: "init",
                        templateUrl: "Templates/uploads/bulkChequeReceipt.tpl.html",
                        controller: "bulkChequeReceiptController",
                    })


                    ////////////////////////////  end Uploads  ///////////////////////////


                    ////////////////////////////  HR ///////////////////////////


                    .state("AttachmentType", {
                        parent: "init",
                        url: "/AttachmentType",
                        templateUrl: "templates/hr/AttachmentType.tpl.html",
                        controller: "AttachmentTypeController",
                    })

                    .state("EmployeeAttachment", {
                        parent: "init",
                        url: "/EmployeeAttachment",
                        templateUrl: "templates/hr/EmployeeAttachment.tpl.html",
                        controller: "EmployeeAttachmentController",
                    })

                    .state("attachmentByEmployee", {
                        parent: "init",
                        url: "/attachmentByEmployee/:EmployeeId",
                        templateUrl: "templates/hr/EmployeeAttachment.tpl.html",
                        controller: "EmployeeAttachmentController",
                    })

                    .state("appraisalsByEmployee", {
                        parent: "init",
                        url: "/appraisalsByEmployee/:EmployeeId",
                        templateUrl: "templates/hr/EmployeeAppraisals.tpl.html",
                        controller: "EmployeeAppraisalsController",
                    })

                    .state("EmployeeAppraisals", {
                        parent: "init",
                        url: "/EmployeeAppraisals",
                        templateUrl: "templates/hr/EmployeeAppraisals.tpl.html",
                        controller: "EmployeeAppraisalsController",
                    })

                    .state("addEmployeeAppraisals", {
                        parent: "init",
                        url: "/addEmployeeAppraisals",
                        templateUrl: "templates/hr/addEmployeeAppraisals.tpl.html",
                        controller: "addEmployeeAppraisalsController",
                    })
                    .state("editEmployeeAppraisals", {
                        parent: "init",
                        url: "/editEmployeeAppraisals/:AppId",
                        templateUrl: "templates/hr/addEmployeeAppraisals.tpl.html",
                        controller: "addEmployeeAppraisalsController",
                    })

                    .state("ResignationForm", {
                        parent: "init",
                        url: "/ResignationForm",
                        templateUrl: "templates/hr/ResignationForm.tpl.html",
                        controller: "ResignationFormController",
                    })

                    .state("WarningLetter", {
                        parent: "init",
                        url: "/WarningLetter",
                        templateUrl: "templates/hr/WarningLetter.tpl.html",
                        controller: "WarningLetterController",
                    })

                    .state("VacationRequest", {
                        parent: "init",
                        url: "/VacationRequest",
                        templateUrl: "templates/hr/VacationRequest.tpl.html",
                        controller: "VacationRequestController",
                    })

                    .state("vacationJoin", {
                        parent: "init",
                        url: "/vacationJoin",
                        templateUrl: "templates/hr/vacationJoin.tpl.html",
                        controller: "vacationJoinController",
                    })

                    .state("viewVacationRequest", {
                        parent: "init",
                        url: "/viewVacationRequest",
                        templateUrl: "templates/hr/viewVacationRequest.tpl.html",
                        controller: "viewVacationRequestController",
                    })

                    .state("viewResignationForm", {
                        parent: "init",
                        url: "/viewResignationForm",
                        templateUrl: "templates/hr/viewResignationForm.tpl.html",
                        controller: "viewResignationFormController",
                    })

                    .state("ViewWarningLetters", {
                        parent: "init",
                        url: "/ViewWarningLetters",
                        templateUrl: "templates/hr/ViewWarningLetters.tpl.html",
                        controller: "ViewWarningLettersController",
                    })

                    .state("workType", {
                        url: "/workType",
                        parent: "init",
                        templateUrl: "Templates/hr/workType.tpl.html",
                        controller: "workTypeController",
                    })

                    .state("Grade", {
                        url: "/Grade",
                        parent: "init",
                        templateUrl: "Templates/hr/Grade.tpl.html",
                        controller: "GradeController",
                    })

                    .state("Shift", {
                        url: "/Shift",
                        parent: "init",
                        templateUrl: "Templates/hr/Shift.tpl.html",
                        controller: "ShiftController",
                    })

                    .state("PayrollComponent", {
                        url: "/PayrollComponent",
                        parent: "init",
                        templateUrl: "Templates/hr/PayrollComponent.tpl.html",
                        controller: "PayrollComponentController",
                    })

                    .state("LeaveAllocation", {
                        url: "/LeaveAllocation",
                        parent: "init",
                        templateUrl: "Templates/hr/LeaveAllocation.tpl.html",
                        controller: "LeaveAllocationController",
                    })

                    .state("EmployeeLeaveLedger", {
                        url: "/EmployeeLeaveLedger",
                        parent: "init",
                        templateUrl: "Templates/hr/EmployeeLeaveLedger.tpl.html",
                        controller: "EmployeeLeaveLedgerController",
                    })

                    .state("employeeVacationLedger", {
                        url: "/employeeVacationLedger",
                        parent: "init",
                        templateUrl: "Templates/hr/employeeVacationLedger.tpl.html",
                        controller: "employeeVacationLedgerController",
                    })

                    .state("ApplyLeave", {
                        url: "/ApplyLeave",
                        parent: "init",
                        templateUrl: "Templates/hr/ApplyLeave.tpl.html",
                        controller: "ApplyLeaveController",
                    })
                    .state("leaveList", {
                        url: "/leaveList",
                        parent: "init",
                        templateUrl: "Templates/hr/leaveList.tpl.html",
                        controller: "leaveListController",
                    })

                    .state("payrollSettings", {
                        url: "/payrollSettings",
                        parent: "init",
                        templateUrl: "Templates/hr/payrollSettings.tpl.html",
                        controller: "payrollSettingsController",
                    })

                    .state("payrollSettingsGrade", {
                        url: "/payrollSettingsGrade",
                        parent: "init",
                        templateUrl: "Templates/hr/payrollSettingsGrade.tpl.html",
                        controller: "payrollSettingsGradeController",
                    })

                    .state("holiday", {
                        url: "/holiday",
                        parent: "init",
                        templateUrl: "Templates/hr/holiday.tpl.html",
                        controller: "holidayController",
                    })

                    .state("vacationSettings", {
                        url: "/vacationSettings",
                        parent: "init",
                        templateUrl: "Templates/hr/vacationSettings.tpl.html",
                        controller: "vacationSettingsController",
                    })

                    .state("employeeAttendance", {
                        url: "/employeeAttendance",
                        parent: "init",
                        templateUrl: "Templates/hr/employeeAttendance.tpl.html",
                        controller: "employeeAttendanceController",
                    })

                    .state("employeeAttendanceGrade", {
                        url: "/employeeAttendanceGrade",
                        parent: "init",
                        templateUrl: "Templates/hr/employeeAttendance.tpl.html",
                        controller: "employeeAttendanceController",
                    })

                    .state("EarningDeduction", {
                        url: "/EarningDeduction",
                        parent: "init",
                        templateUrl: "Templates/hr/EarningDeduction.tpl.html",
                        controller: "EarningDeductionController",
                    })

                    .state("editEarningDeduction", {
                        url: "/editEarningDeduction/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/hr/EarningDeduction.tpl.html",
                        controller: "EarningDeductionController",
                    })

                    .state("EarningDeductionList", {
                        url: "/EarningDeductionList",
                        parent: "init",
                        templateUrl: "Templates/hr/EarningDeductionList.tpl.html",
                        controller: "EarningDeductionListController",
                    })

                    .state("addEmployeeSalary", {
                        url: "/addEmployeeSalary",
                        parent: "init",
                        templateUrl: "Templates/hr/addEmployeeSalary.tpl.html",
                        controller: "addEmployeeSalaryController",
                    })
                    .state("editEmployeeSalary", {
                        url: "/editEmployeeSalary/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/hr/addEmployeeSalary.tpl.html",
                        controller: "addEmployeeSalaryController",
                    })
                     .state("bulkEmployeeSalary", {
                        url: "/bulkEmployeeSalary",
                        parent: "init",
                        templateUrl: "Templates/hr/bulkEmployeeSalary.tpl.html",
                        controller: "bulkEmployeeSalaryController",
                    })

                    .state("employeeSalary", {
                        url: "/employeeSalary",
                        parent: "init",
                        templateUrl: "Templates/hr/employeeSalary.tpl.html",
                        controller: "employeeSalaryController",
                    })

                    .state("openingLoan", {
                        parent: "init",
                        url: "/openingLoan",
                        templateUrl: "templates/hr/openingLoan.tpl.html",
                        controller: "openingLoanController",
                    })

                    .state("editOpeningLoan", {
                        parent: "init",
                        url: "/editOpeningLoan/:VoucherId",
                        templateUrl: "templates/hr/openingLoan.tpl.html",
                        controller: "openingLoanController",
                    })

                    .state("openingLoanList", {
                        parent: "init",
                        url: "/openingLoanList",
                        templateUrl: "templates/hr/openingLoanList.tpl.html",
                        controller: "openingLoanListController",
                    })

                    .state("employeeLoan", {
                        parent: "init",
                        url: "/employeeLoan",
                        templateUrl: "templates/hr/employeeLoan.tpl.html",
                        controller: "employeeLoanController",
                    })

                    .state("editEmployeeLoan", {
                        parent: "init",
                        url: "/editEmployeeLoan/:VoucherId",
                        templateUrl: "templates/hr/employeeLoan.tpl.html",
                        controller: "employeeLoanController",
                    })

                    .state("employeeLoanList", {
                        parent: "init",
                        url: "/employeeLoanList",
                        templateUrl: "templates/hr/employeeLoanList.tpl.html",
                        controller: "employeeLoanListController",
                    })


                    ////////////////////////////  end HR  ///////////////////////////


                    //////////////////////////////////////**** POS ****////////////////////

                    .state("counter", {
                        url: "/counter",
                        parent: "init",
                        templateUrl: "Templates/pos/counter.tpl.html",
                        controller: "counterController",
                    })

                    .state("counterSales", {
                        url: "/counterSales",
                        parent: "init",
                        templateUrl: "Templates/pos/counterSales.tpl.html",
                        controller: "counterSalesController",
                    })

                    .state("counterSalesEdit", {
                        url: "/counterSalesEdit/:SaleId",
                        parent: "init",
                        templateUrl: "Templates/pos/counterSalesEdit.tpl.html",
                        controller: "counterSalesEditController",
                    })

                    .state("counterSalesTouch", {
                        url: "/counterSalesTouch",
                        parent: "init",
                        templateUrl: "Templates/pos/counterSalesTouch.tpl.html",
                        controller: "counterSalesTouchController",
                    })

                    .state("counterSalesTouch2", {
                        url: "/counterSalesTouch2",
                        parent: "init",
                        templateUrl: "Templates/pos/counterSalesTouch2.tpl.html",
                        controller: "counterSalesTouchController",
                    })


                    .state("counterSalesTable", {
                        url: "/counterSalesTable",
                        parent: "init",
                        templateUrl: "Templates/pos/counterSalesTable.tpl.html",
                        controller: "counterSalesTableController",
                    })

                    .state("billReview", {
                        url: "/billReview",
                        parent: "init",
                        templateUrl: "Templates/pos/billReview.tpl.html",
                        controller: "billReviewController",
                    })

                    //////////////////////////////////////**** End POS ****////////////////////

                    //////////////////////////////////***** Sales *****/////////////////////////////////


                    .state("SalesEnquiry", {
                        url: "/SalesEnquiry",
                        parent: "init",
                        templateUrl: "Templates/sales/salesEnquiry.tpl.html",
                        controller: "SalesEnquiryController",
                    })

                    .state("addSalesEnquiry", {
                        url: "/addSalesEnquiry",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry.tpl.html",
                        controller: "addSalesEnquiryController",
                    })

                    .state("editSalesEnquiry", {
                        url: "/editSalesEnquiry/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry.tpl.html",
                        controller: "addSalesEnquiryController",
                    })

                    .state("linkSalesEnquiry", {
                        url: "/linkSalesEnquiry/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry.tpl.html",
                        controller: "addSalesEnquiryController",
                    })

                    .state("viewSalesEnquiry", {
                        url: "/viewSalesEnquiry/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesEnquiry.tpl.html",
                        controller: "viewSalesEnquiryController",
                    })




                    .state("SalesEnquiry2", {
                        url: "/SalesEnquiry2",
                        parent: "init",
                        templateUrl: "Templates/sales/salesEnquiry2.tpl.html",
                        controller: "SalesEnquiry2Controller",
                    })

                    .state("addSalesEnquiry2", {
                        url: "/addSalesEnquiry2",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry2.tpl.html",
                        controller: "addSalesEnquiry2Controller",
                    })

                    .state("editSalesEnquiry2", {
                        url: "/editSalesEnquiry2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry2.tpl.html",
                        controller: "addSalesEnquiry2Controller",
                    })

                    .state("linkSalesEnquiry2", {
                        url: "/linkSalesEnquiry2/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry2.tpl.html",
                        controller: "addSalesEnquiry2Controller",
                    })

                    .state("viewSalesEnquiry2", {
                        url: "/viewSalesEnquiry2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesEnquiry2.tpl.html",
                        controller: "viewSalesEnquiry2Controller",
                    })



                    .state("SalesEnquiry3", {
                        url: "/SalesEnquiry3",
                        parent: "init",
                        templateUrl: "Templates/sales/salesEnquiry3.tpl.html",
                        controller: "SalesEnquiry3Controller",
                    })

                    .state("addSalesEnquiry3", {
                        url: "/addSalesEnquiry3",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry3.tpl.html",
                        controller: "addSalesEnquiry3Controller",
                    })

                    .state("editSalesEnquiry3", {
                        url: "/editSalesEnquiry3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry3.tpl.html",
                        controller: "addSalesEnquiry3Controller",
                    })

                    .state("linkSalesEnquiry3", {
                        url: "/linkSalesEnquiry3/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry3.tpl.html",
                        controller: "addSalesEnquiry3Controller",
                    })

                    .state("viewSalesEnquiry3", {
                        url: "/viewSalesEnquiry3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesEnquiry3.tpl.html",
                        controller: "viewSalesEnquiry3Controller",
                    })




                    .state("SalesEnquiry4", {
                        url: "/SalesEnquiry4",
                        parent: "init",
                        templateUrl: "Templates/sales/salesEnquiry4.tpl.html",
                        controller: "SalesEnquiry4Controller",
                    })

                    .state("addSalesEnquiry4", {
                        url: "/addSalesEnquiry4",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry4.tpl.html",
                        controller: "addSalesEnquiry4Controller",
                    })

                    .state("editSalesEnquiry4", {
                        url: "/editSalesEnquiry4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry4.tpl.html",
                        controller: "addSalesEnquiry4Controller",
                    })

                    .state("linkSalesEnquiry4", {
                        url: "/linkSalesEnquiry4/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesEnquiry4.tpl.html",
                        controller: "addSalesEnquiry4Controller",
                    })

                    .state("viewSalesEnquiry4", {
                        url: "/viewSalesEnquiry4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesEnquiry4.tpl.html",
                        controller: "viewSalesEnquiry4Controller",
                    })



                    .state("SalesQuotation", {
                        url: "/SalesQuotation",
                        parent: "init",
                        templateUrl: "Templates/sales/salesQuotation.tpl.html",
                        controller: "SalesQuotationController",
                    })

                    .state("addSalesQuotation", {
                        url: "/addSalesQuotation",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation.tpl.html",
                        controller: "addSalesQuotationController",
                    })

                    .state("editSalesQuotation", {
                        url: "/editSalesQuotation/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation.tpl.html",
                        controller: "addSalesQuotationController",
                    })

                    .state("linkSalesQuotation", {
                        url: "/linkSalesQuotation/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation.tpl.html",
                        controller: "addSalesQuotationController",
                    })

                    .state("viewSalesQuotation", {
                        url: "/viewSalesQuotation/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesQuotation.tpl.html",
                        controller: "viewSalesQuotationController",
                    })


                    ////////////////////SalesQuotation2////////////////



                    .state("SalesQuotation2", {
                        url: "/SalesQuotation2",
                        parent: "init",
                        templateUrl: "Templates/sales/salesQuotation2.tpl.html",
                        controller: "SalesQuotation2Controller",
                    })

                    .state("addSalesQuotation2", {
                        url: "/addSalesQuotation2",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation2.tpl.html",
                        controller: "addSalesQuotation2Controller",
                    })

                    .state("editSalesQuotation2", {
                        url: "/editSalesQuotation2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation2.tpl.html",
                        controller: "addSalesQuotation2Controller",
                    })

                    .state("linkSalesQuotation2", {
                        url: "/linkSalesQuotation2/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation2.tpl.html",
                        controller: "addSalesQuotation2Controller",
                    })

                    .state("viewSalesQuotation2", {
                        url: "/viewSalesQuotation2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesQuotation2.tpl.html",
                        controller: "viewSalesQuotation2Controller",
                    })

                    ////////////////////SalesQuotation3////////////////



                    .state("SalesQuotation3", {
                        url: "/SalesQuotation3",
                        parent: "init",
                        templateUrl: "Templates/sales/salesQuotation3.tpl.html",
                        controller: "SalesQuotation3Controller",
                    })

                    .state("addSalesQuotation3", {
                        url: "/addSalesQuotation3",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation3.tpl.html",
                        controller: "addSalesQuotation3Controller",
                    })

                    .state("editSalesQuotation3", {
                        url: "/editSalesQuotation3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation3.tpl.html",
                        controller: "addSalesQuotation3Controller",
                    })

                    .state("linkSalesQuotation3", {
                        url: "/linkSalesQuotation3/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation3.tpl.html",
                        controller: "addSalesQuotation3Controller",
                    })

                    .state("viewSalesQuotation3", {
                        url: "/viewSalesQuotation3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesQuotation3.tpl.html",
                        controller: "viewSalesQuotation3Controller",
                    })

                    ////////////////////SalesQuotation4////////////////



                    .state("SalesQuotation4", {
                        url: "/SalesQuotation4",
                        parent: "init",
                        templateUrl: "Templates/sales/salesQuotation4.tpl.html",
                        controller: "SalesQuotation4Controller",
                    })

                    .state("addSalesQuotation4", {
                        url: "/addSalesQuotation4",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation4.tpl.html",
                        controller: "addSalesQuotation4Controller",
                    })

                    .state("editSalesQuotation4", {
                        url: "/editSalesQuotation4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation4.tpl.html",
                        controller: "addSalesQuotation4Controller",
                    })

                    .state("linkSalesQuotation4", {
                        url: "/linkSalesQuotation4/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesQuotation4.tpl.html",
                        controller: "addSalesQuotation4Controller",
                    })

                    .state("viewSalesQuotation4", {
                        url: "/viewSalesQuotation4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesQuotation4.tpl.html",
                        controller: "viewSalesQuotation4Controller",
                    })


                    //////////////////////////////PackingList//////////////

                    .state("PackingList", {
                        url: "/PackingList",
                        parent: "init",
                        templateUrl: "Templates/sales/PackingList.tpl.html",
                        controller: "PackingListController",
                    })


                    .state("addPackingList", {
                        url: "/addPackingList",
                        parent: "init",
                        templateUrl: "Templates/sales/addPackingList.tpl.html",
                        controller: "addPackingListController",
                    })

                    .state("editPackingList", {
                        url: "/editPackingList/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addPackingList.tpl.html",
                        controller: "addPackingListController",
                    })


                    .state("linkPackingList", {
                        url: "/linkPackingList/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addPackingList.tpl.html",
                        controller: "addPackingListController",
                    })


                    .state("viewPackingList", {
                        url: "/viewPackingList/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewPackingList.tpl.html",
                        controller: "viewPackingListController",
                    })



                    .state("SalesOrder", {
                        url: "/SalesOrder",
                        parent: "init",
                        templateUrl: "Templates/sales/salesOrder.tpl.html",
                        controller: "SalesOrderController",
                    })


                    .state("addSalesOrder", {
                        url: "/addSalesOrder",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder.tpl.html",
                        controller: "addSalesOrderController",
                    })

                    .state("editSalesOrder", {
                        url: "/editSalesOrder/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder.tpl.html",
                        controller: "addSalesOrderController",
                    })


                    .state("linkSalesOrder", {
                        url: "/linkSalesOrder/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder.tpl.html",
                        controller: "addSalesOrderController",
                    })


                    .state("viewSalesOrder", {
                        url: "/viewSalesOrder/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesOrder.tpl.html",
                        controller: "viewSalesOrderController",
                    })


                    ////////////////////////////SalesOrder2///////////////////


                    .state("SalesOrder2", {
                        url: "/SalesOrder2",
                        parent: "init",
                        templateUrl: "Templates/sales/salesOrder2.tpl.html",
                        controller: "SalesOrder2Controller",
                    })


                    .state("addSalesOrder2", {
                        url: "/addSalesOrder2",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder2.tpl.html",
                        controller: "addSalesOrder2Controller",
                    })

                    .state("editSalesOrder2", {
                        url: "/editSalesOrder2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder2.tpl.html",
                        controller: "addSalesOrder2Controller",
                    })


                    .state("linkSalesOrder2", {
                        url: "/linkSalesOrder2/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder2.tpl.html",
                        controller: "addSalesOrder2Controller",
                    })


                    .state("viewSalesOrder2", {
                        url: "/viewSalesOrder2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesOrder2.tpl.html",
                        controller: "viewSalesOrder2Controller",
                    })
                    ////////////////////////////SalesOrder3///////////////////


                    .state("SalesOrder3", {
                        url: "/SalesOrder3",
                        parent: "init",
                        templateUrl: "Templates/sales/salesOrder3.tpl.html",
                        controller: "SalesOrder3Controller",
                    })


                    .state("addSalesOrder3", {
                        url: "/addSalesOrder3",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder3.tpl.html",
                        controller: "addSalesOrder3Controller",
                    })

                    .state("editSalesOrder3", {
                        url: "/editSalesOrder3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder3.tpl.html",
                        controller: "addSalesOrder3Controller",
                    })


                    .state("linkSalesOrder3", {
                        url: "/linkSalesOrder3/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder3.tpl.html",
                        controller: "addSalesOrder3Controller",
                    })


                    .state("viewSalesOrder3", {
                        url: "/viewSalesOrder3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesOrder3.tpl.html",
                        controller: "viewSalesOrder3Controller",
                    })
                    ////////////////////////////SalesOrder4///////////////////

                    .state("SalesOrder4", {
                        url: "/SalesOrder4",
                        parent: "init",
                        templateUrl: "Templates/sales/salesOrder4.tpl.html",
                        controller: "SalesOrder4Controller",
                    })


                    .state("addSalesOrder4", {
                        url: "/addSalesOrder4",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder4.tpl.html",
                        controller: "addSalesOrder4Controller",
                    })

                    .state("editSalesOrder4", {
                        url: "/editSalesOrder4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder4.tpl.html",
                        controller: "addSalesOrder4Controller",
                    })


                    .state("linkSalesOrder4", {
                        url: "/linkSalesOrder4/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesOrder4.tpl.html",
                        controller: "addSalesOrder4Controller",
                    })


                    .state("viewSalesOrder4", {
                        url: "/viewSalesOrder4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesOrder4.tpl.html",
                        controller: "viewSalesOrder4Controller",
                    })

                    //////////////////DeliveryNote////////////////////////

                    .state("DeliveryNote", {
                        url: "/DeliveryNote",
                        parent: "init",
                        templateUrl: "Templates/sales/deliveryNote.tpl.html",
                        controller: "DeliveryNoteController",
                    })


                    .state("addDeliveryNote", {
                        url: "/addDeliveryNote",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote.tpl.html",
                        controller: "addDeliveryNoteController",
                    })

                    .state("editDeliveryNote", {
                        url: "/editDeliveryNote/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote.tpl.html",
                        controller: "addDeliveryNoteController",
                    })

                    .state("linkDeliveryNote", {
                        url: "/linkDeliveryNote/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote.tpl.html",
                        controller: "addDeliveryNoteController",
                    })

                    .state("viewDeliveryNote", {
                        url: "/viewDeliveryNote/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewDeliveryNote.tpl.html",
                        controller: "viewDeliveryNoteController",
                    })


                    //////////////////DeliveryNote2////////////////////////

                    .state("DeliveryNote2", {
                        url: "/DeliveryNote2",
                        parent: "init",
                        templateUrl: "Templates/sales/deliveryNote2.tpl.html",
                        controller: "DeliveryNote2Controller",
                    })


                    .state("addDeliveryNote2", {
                        url: "/addDeliveryNote2",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote2.tpl.html",
                        controller: "addDeliveryNote2Controller",
                    })

                    .state("editDeliveryNote2", {
                        url: "/editDeliveryNote2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote2.tpl.html",
                        controller: "addDeliveryNote2Controller",
                    })

                    .state("linkDeliveryNote2", {
                        url: "/linkDeliveryNote2/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote2.tpl.html",
                        controller: "addDeliveryNote2Controller",
                    })

                    .state("viewDeliveryNote2", {
                        url: "/viewDeliveryNote2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewDeliveryNote2.tpl.html",
                        controller: "viewDeliveryNote2Controller",
                    })

                    .state("approvalDeliveryNote2", {
                        url: "/approvalDeliveryNote2",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalDeliveryNote2.tpl.html",
                        controller: "approvalDeliveryNote2Controller",
                    })

                    .state("approvalDeliveryNote3", {
                        url: "/approvalDeliveryNote3",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalDeliveryNote3.tpl.html",
                        controller: "approvalDeliveryNote3Controller",
                    })

                    .state("approvalDeliveryNote4", {
                        url: "/approvalDeliveryNote4",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalDeliveryNote4.tpl.html",
                        controller: "approvalDeliveryNote4Controller",
                    })

                    .state("approvalDeliveryNote", {
                        url: "/approvalDeliveryNote",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalDeliveryNote.tpl.html",
                        controller: "approvalDeliveryNoteController",
                    })

                    .state("approvalDirSalesInvoice", {
                        url: "/approvalDirSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalDirSalesInvoice.tpl.html",
                        controller: "approvalDirSalesInvoiceController",
                    })


                    .state("approvalExpSalesInvoice", {
                        url: "/approvalExpSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalExpSalesInvoice.tpl.html",
                        controller: "approvalExpSalesInvoiceController",
                    })


                    .state("approvalIndSalesInvoice", {
                        url: "/approvalIndSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalIndSalesInvoice.tpl.html",
                        controller: "approvalIndSalesInvoiceController",
                    })


                    .state("approvalPackingList", {
                        url: "/approvalPackingList",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalPackingList.tpl.html",
                        controller: "approvalPackingListController",
                    })


                    .state("approvalPorSalesInvoice", {
                        url: "/approvalPorSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalPorSalesInvoice.tpl.html",
                        controller: "approvalPorSalesInvoiceController",
                    })


                    .state("approvalSalesEnquiry", {
                        url: "/approvalSalesEnquiry",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesEnquiry.tpl.html",
                        controller: "approvalSalesEnquiryController",
                    })


                    .state("approvalSalesEnquiry2", {
                        url: "/approvalSalesEnquiry2",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesEnquiry2.tpl.html",
                        controller: "approvalSalesEnquiry2Controller",
                    })



                    .state("approvalSalesEnquiry3", {
                        url: "/approvalSalesEnquiry3",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesEnquiry3.tpl.html",
                        controller: "approvalSalesEnquiry3Controller",
                    })


                    .state("approvalSalesEnquiry4", {
                        url: "/approvalSalesEnquiry4",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesEnquiry4.tpl.html",
                        controller: "approvalSalesEnquiry4Controller",
                    })


                    .state("approvalSalesInvoice", {
                        url: "/approvalSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesInvoice.tpl.html",
                        controller: "approvalSalesInvoiceController",
                    })

                    .state("approvalSalesInvoice2", {
                        url: "/approvalSalesInvoice2",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesInvoice2.tpl.html",
                        controller: "approvalSalesInvoice2Controller",
                    })

                    .state("approvalSalesInvoice3", {
                        url: "/approvalSalesInvoice3",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesInvoice3.tpl.html",
                        controller: "approvalSalesInvoice3Controller",
                    })


                    .state("approvalSalesInvoice4", {
                        url: "/approvalSalesInvoice4",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesInvoice4.tpl.html",
                        controller: "approvalSalesInvoice4Controller",
                    })

                    .state("approvalSalesOrder", {
                        url: "/approvalSalesOrder",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesOrder.tpl.html",
                        controller: "approvalSalesOrderController",
                    })

                    .state("approvalSalesOrder2", {
                        url: "/approvalSalesOrder2",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesOrder2.tpl.html",
                        controller: "approvalSalesOrder2Controller",
                    })

                    .state("approvalSalesOrder3", {
                        url: "/approvalSalesOrder3",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesOrder3.tpl.html",
                        controller: "approvalSalesOrder3Controller",
                    })

                    .state("approvalSalesOrder4", {
                        url: "/approvalSalesOrder4",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesOrder4.tpl.html",
                        controller: "approvalSalesOrder4Controller",
                    })

                    .state("approvalSalesQuotation", {
                        url: "/approvalSalesQuotation",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesQuotation.tpl.html",
                        controller: "approvalSalesQuotationController",
                    })

                    .state("approvalSalesQuotation2", {
                        url: "/approvalSalesQuotation2",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesQuotation2.tpl.html",
                        controller: "approvalSalesQuotation2Controller",
                    })

                    .state("approvalSalesQuotation3", {
                        url: "/approvalSalesQuotation3",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesQuotation3.tpl.html",
                        controller: "approvalSalesQuotation3Controller",
                    })

                    .state("approvalSalesQuotation4", {
                        url: "/approvalSalesQuotation4",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesQuotation4.tpl.html",
                        controller: "approvalSalesQuotation4Controller",
                    })

                    .state("approvalSalesReturn", {
                        url: "/approvalSalesReturn",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalSalesReturn.tpl.html",
                        controller: "approvalSalesReturnController",
                    })


                    //////////////////DeliveryNote3////////////////////////

                    .state("DeliveryNote3", {
                        url: "/DeliveryNote3",
                        parent: "init",
                        templateUrl: "Templates/sales/deliveryNote3.tpl.html",
                        controller: "DeliveryNote3Controller",
                    })


                    .state("addDeliveryNote3", {
                        url: "/addDeliveryNote3",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote3.tpl.html",
                        controller: "addDeliveryNote3Controller",
                    })

                    .state("editDeliveryNote3", {
                        url: "/editDeliveryNote3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote3.tpl.html",
                        controller: "addDeliveryNote3Controller",
                    })

                    .state("linkDeliveryNote3", {
                        url: "/linkDeliveryNote3/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote3.tpl.html",
                        controller: "addDeliveryNote3Controller",
                    })

                    .state("viewDeliveryNote3", {
                        url: "/viewDeliveryNote3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewDeliveryNote3.tpl.html",
                        controller: "viewDeliveryNote3Controller",
                    })



                    //////////////////DeliveryNote4////////////////////////

                    .state("DeliveryNote4", {
                        url: "/DeliveryNote4",
                        parent: "init",
                        templateUrl: "Templates/sales/deliveryNote4.tpl.html",
                        controller: "DeliveryNote4Controller",
                    })


                    .state("addDeliveryNote4", {
                        url: "/addDeliveryNote4",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote4.tpl.html",
                        controller: "addDeliveryNote4Controller",
                    })

                    .state("editDeliveryNote4", {
                        url: "/editDeliveryNote4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote4.tpl.html",
                        controller: "addDeliveryNote4Controller",
                    })

                    .state("linkDeliveryNote4", {
                        url: "/linkDeliveryNote4/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addDeliveryNote4.tpl.html",
                        controller: "addDeliveryNote4Controller",
                    })

                    .state("viewDeliveryNote4", {
                        url: "/viewDeliveryNote4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewDeliveryNote4.tpl.html",
                        controller: "viewDeliveryNote4Controller",
                    })



                    ///////////////////////SalesInvoice/////////////////

                    .state("SalesInvoice", {
                        url: "/SalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/salesInvoice.tpl.html",
                        controller: "SalesInvoiceController",
                    })


                    .state("addSalesInvoice", {
                        url: "/addSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice.tpl.html",
                        controller: "addSalesInvoiceController",
                    })

                    .state("editSalesInvoice", {
                        url: "/editSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice.tpl.html",
                        controller: "addSalesInvoiceController",
                    })

                    .state("linkSalesInvoice", {
                        url: "/linkSalesInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice.tpl.html",
                        controller: "addSalesInvoiceController",
                    })

                    .state("viewSalesInvoice", {
                        url: "/viewSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesInvoice.tpl.html",
                        controller: "viewSalesInvoiceController",
                    })



                    ///////////////////////SalesInvoice2/////////////////

                    .state("SalesInvoice2", {
                        url: "/SalesInvoice2",
                        parent: "init",
                        templateUrl: "Templates/sales/salesInvoice2.tpl.html",
                        controller: "SalesInvoice2Controller",
                    })


                    .state("addSalesInvoice2", {
                        url: "/addSalesInvoice2",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice2.tpl.html",
                        controller: "addSalesInvoice2Controller",
                    })

                    .state("editSalesInvoice2", {
                        url: "/editSalesInvoice2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice2.tpl.html",
                        controller: "addSalesInvoice2Controller",
                    })

                    .state("linkSalesInvoice2", {
                        url: "/linkSalesInvoice2/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice2.tpl.html",
                        controller: "addSalesInvoice2Controller",
                    })

                    .state("viewSalesInvoice2", {
                        url: "/viewSalesInvoice2/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesInvoice2.tpl.html",
                        controller: "viewSalesInvoice2Controller",
                    })


                    ///////////////////////SalesInvoice3/////////////////

                    .state("SalesInvoice3", {
                        url: "/SalesInvoice3",
                        parent: "init",
                        templateUrl: "Templates/sales/salesInvoice3.tpl.html",
                        controller: "SalesInvoice3Controller",
                    })


                    .state("addSalesInvoice3", {
                        url: "/addSalesInvoice3",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice3.tpl.html",
                        controller: "addSalesInvoice3Controller",
                    })

                    .state("editSalesInvoice3", {
                        url: "/editSalesInvoice3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice3.tpl.html",
                        controller: "addSalesInvoice3Controller",
                    })

                    .state("linkSalesInvoice3", {
                        url: "/linkSalesInvoice3/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice3.tpl.html",
                        controller: "addSalesInvoice3Controller",
                    })

                    .state("viewSalesInvoice3", {
                        url: "/viewSalesInvoice3/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesInvoice3.tpl.html",
                        controller: "viewSalesInvoice3Controller",
                    })



                    ///////////////////////SalesInvoice4/////////////////

                    .state("SalesInvoice4", {
                        url: "/SalesInvoice4",
                        parent: "init",
                        templateUrl: "Templates/sales/salesInvoice4.tpl.html",
                        controller: "SalesInvoice4Controller",
                    })


                    .state("addSalesInvoice4", {
                        url: "/addSalesInvoice4",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice4.tpl.html",
                        controller: "addSalesInvoice4Controller",
                    })

                    .state("editSalesInvoice4", {
                        url: "/editSalesInvoice4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice4.tpl.html",
                        controller: "addSalesInvoice4Controller",
                    })

                    .state("linkSalesInvoice4", {
                        url: "/linkSalesInvoice4/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesInvoice4.tpl.html",
                        controller: "addSalesInvoice4Controller",
                    })

                    .state("viewSalesInvoice4", {
                        url: "/viewSalesInvoice4/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesInvoice4.tpl.html",
                        controller: "viewSalesInvoice4Controller",
                    })


                    ////////////////////////////////DirSalesInvoice////////////////////

                    .state("DirSalesInvoice", {
                        url: "/DirSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/DirsalesInvoice.tpl.html",
                        controller: "DirSalesInvoiceController",
                    })

                    .state("addDirSalesInvoice", {
                        url: "/addDirSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/addDirSalesInvoice.tpl.html",
                        controller: "addDirSalesInvoiceController",
                    })

                    .state("editDirSalesInvoice", {
                        url: "/editDirSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addDirSalesInvoice.tpl.html",
                        controller: "addDirSalesInvoiceController",
                    })

                    .state("linkDirSalesInvoice", {
                        url: "/linkDirSalesInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addDirSalesInvoice.tpl.html",
                        controller: "addDirSalesInvoiceController",
                    })

                    .state("viewDirSalesInvoice", {
                        url: "/viewDirSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewDirSalesInvoice.tpl.html",
                        controller: "viewDirSalesInvoiceController",
                    })


                    .state("IndSalesInvoice", {
                        url: "/IndSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/IndSalesInvoice.tpl.html",
                        controller: "IndSalesInvoiceController",
                    })

                    .state("addIndSalesInvoice", {
                        url: "/addIndSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/addIndSalesInvoice.tpl.html",
                        controller: "addIndSalesInvoiceController",
                    })

                    .state("editIndSalesInvoice", {
                        url: "/editIndSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addIndSalesInvoice.tpl.html",
                        controller: "addIndSalesInvoiceController",
                    })

                    .state("linkIndSalesInvoice", {
                        url: "/linkIndSalesInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addIndSalesInvoice.tpl.html",
                        controller: "addIndSalesInvoiceController",
                    })

                    .state("viewIndSalesInvoice", {
                        url: "/viewIndSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewIndSalesInvoice.tpl.html",
                        controller: "viewIndSalesInvoiceController",
                    })

                    .state("ExpSalesInvoice", {
                        url: "/ExpSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/ExpsalesInvoice.tpl.html",
                        controller: "ExpSalesInvoiceController",
                    })

                    .state("addExpSalesInvoice", {
                        url: "/addExpSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/addExpSalesInvoice.tpl.html",
                        controller: "addExpSalesInvoiceController",
                    })

                    .state("editExpSalesInvoice", {
                        url: "/editExpSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addExpSalesInvoice.tpl.html",
                        controller: "addExpSalesInvoiceController",
                    })

                    .state("linkExpSalesInvoice", {
                        url: "/linkExpSalesInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addExpSalesInvoice.tpl.html",
                        controller: "addExpSalesInvoiceController",
                    })

                    .state("viewExpSalesInvoice", {
                        url: "/viewExpSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewExpSalesInvoice.tpl.html",
                        controller: "viewExpSalesInvoiceController",
                    })

                    .state("PorSalesInvoice", {
                        url: "/PorSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/PorsalesInvoice.tpl.html",
                        controller: "PorSalesInvoiceController",
                    })

                    .state("addPorSalesInvoice", {
                        url: "/addPorSalesInvoice",
                        parent: "init",
                        templateUrl: "Templates/sales/addPorSalesInvoice.tpl.html",
                        controller: "addPorSalesInvoiceController",
                    })

                    .state("editPorSalesInvoice", {
                        url: "/editPorSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addPorSalesInvoice.tpl.html",
                        controller: "addPorSalesInvoiceController",
                    })

                    .state("linkPorSalesInvoice", {
                        url: "/linkPorSalesInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addPorSalesInvoice.tpl.html",
                        controller: "addPorSalesInvoiceController",
                    })

                    .state("viewPorSalesInvoice", {
                        url: "/viewPorSalesInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewPorSalesInvoice.tpl.html",
                        controller: "viewPorSalesInvoiceController",
                    })

                    .state("SalesReturn", {
                        url: "/SalesReturn",
                        parent: "init",
                        templateUrl: "Templates/sales/salesReturn.tpl.html",
                        controller: "SalesReturnController",
                    })

                    .state("addSalesReturn", {
                        url: "/addSalesReturn",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesReturn.tpl.html",
                        controller: "addSalesReturnController",
                    })

                    .state("editSalesReturn", {
                        url: "/editSalesReturn/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesReturn.tpl.html",
                        controller: "addSalesReturnController",
                    })

                    .state("linkSalesReturn", {
                        url: "/linkSalesReturn/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addSalesReturn.tpl.html",
                        controller: "addSalesReturnController",
                    })

                    .state("viewSalesReturn", {
                        url: "/viewSalesReturn/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewSalesReturn.tpl.html",
                        controller: "viewSalesReturnController",
                    })

                    .state("CreditNoteSR", {
                        url: "/CreditNoteSR",
                        parent: "init",
                        templateUrl: "Templates/sales/CreditNoteSR.tpl.html",
                        controller: "CreditNoteSRController",
                    })

                    .state("addCreditNoteSR", {
                        url: "/addCreditNoteSR",
                        parent: "init",
                        templateUrl: "Templates/sales/addCreditNoteSR.tpl.html",
                        controller: "addCreditNoteSRController",
                    })

                    .state("editCreditNoteSR", {
                        url: "/editCreditNoteSR/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/addCreditNoteSR.tpl.html",
                        controller: "addCreditNoteSRController",
                    })

                    .state("linkCreditNoteSR", {
                        url: "/linkCreditNoteSR/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/sales/addCreditNoteSR.tpl.html",
                        controller: "addCreditNoteSRController",
                    })

                    .state("viewCreditNoteSR", {
                        url: "/viewCreditNoteSR/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/sales/viewCreditNoteSR.tpl.html",
                        controller: "viewCreditNoteSRController",
                    })

                    .state("approvalCreditNoteSR", {
                        url: "/approvalCreditNoteSR",
                        parent: "init",
                        templateUrl: "Templates/sales/approvalCreditNoteSR.tpl.html",
                        controller: "approvalCreditNoteSRController",
                    })


                    ///////////////////////////// end sales ///////////////////////////

                    ///////////////////////////// purchase ///////////////////////////

                    .state("PurchaseEnquiry", {
                        url: "/PurchaseEnquiry",
                        parent: "init",
                        templateUrl: "Templates/purchase/PurchaseEnquiry.tpl.html",
                        controller: "PurchaseEnquiryController",
                    })

                    .state("addPurchaseEnquiry", {
                        url: "/addPurchaseEnquiry",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseEnquiry.tpl.html",
                        controller: "addPurchaseEnquiryController",
                    })

                    .state("editPurchaseEnquiry", {
                        url: "/editPurchaseEnquiry/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseEnquiry.tpl.html",
                        controller: "addPurchaseEnquiryController",
                    })

                    .state("linkPurchaseEnquiry", {
                        url: "/linkPurchaseEnquiry/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseEnquiry.tpl.html",
                        controller: "addPurchaseEnquiryController",
                    })

                    .state("viewPurchaseEnquiry", {
                        url: "/viewPurchaseEnquiry/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewPurchaseEnquiry.tpl.html",
                        controller: "viewPurchaseEnquiryController",
                    })


                    .state("approvalPurchaseEnquiry", {
                        url: "/approvalPurchaseEnquiry",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalPurchaseEnquiry.tpl.html",
                        controller: "approvalPurchaseEnquiryController",
                    })

                    .state("multiPurchaseEnquiry", {
                        url: "/multiPurchaseEnquiry/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/multiPurchaseEnquiry.tpl.html",
                        controller: "multiPurchaseEnquiryController",
                    })

                    .state("PurchaseRequest", {
                        url: "/PurchaseRequest",
                        parent: "init",
                        templateUrl: "Templates/purchase/PurchaseRequest.tpl.html",
                        controller: "PurchaseRequestController",
                    })

                    .state("addPurchaseRequest", {
                        url: "/addPurchaseRequest",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseRequest.tpl.html",
                        controller: "addPurchaseRequestController",
                    })

                    .state("editPurchaseRequest", {
                        url: "/editPurchaseRequest/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseRequest.tpl.html",
                        controller: "addPurchaseRequestController",
                    })

                    .state("linkPurchaseRequest", {
                        url: "/linkPurchaseRequest/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseRequest.tpl.html",
                        controller: "addPurchaseRequestController",
                    })

                    .state("viewPurchaseRequest", {
                        url: "/viewPurchaseRequest/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewPurchaseRequest.tpl.html",
                        controller: "viewPurchaseRequestController",
                    })

                    .state("approvalPurchaseRequest", {
                        url: "/approvalPurchaseRequest",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalPurchaseRequest.tpl.html",
                        controller: "approvalPurchaseRequestController",
                    })


                    /////////////////////////////Material Request///////////////////////////////////////

                    .state("MaterialRequest", {
                        url: "/MaterialRequest",
                        parent: "init",
                        templateUrl: "Templates/purchase/MaterialRequest.tpl.html",
                        controller: "MaterialRequestController",
                    })

                    .state("addMaterialRequest", {
                        url: "/addMaterialRequest",
                        parent: "init",
                        templateUrl: "Templates/purchase/addMaterialRequest.tpl.html",
                        controller: "addMaterialRequestController",
                    })

                    .state("editMaterialRequest", {
                        url: "/editMaterialRequest/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addMaterialRequest.tpl.html",
                        controller: "addMaterialRequestController",
                    })

                    .state("linkMaterialRequest", {
                        url: "/linkMaterialRequest/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addMaterialRequest.tpl.html",
                        controller: "addMaterialRequestController",
                    })

                    .state("viewMaterialRequest", {
                        url: "/viewMaterialRequest/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewMaterialRequest.tpl.html",
                        controller: "viewMaterialRequestController",
                    })

                    .state("approvalMaterialRequest", {
                        url: "/approvalMaterialRequest",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalMaterialRequest.tpl.html",
                        controller: "approvalMaterialRequestController",
                    })


                    ////////////////////////////////////////////// end///////////////////////


                    .state("PurchaseQuotation", {
                        url: "/PurchaseQuotation",
                        parent: "init",
                        templateUrl: "Templates/purchase/PurchaseQuotation.tpl.html",
                        controller: "PurchaseQuotationController",
                    })

                    .state("addPurchaseQuotation", {
                        url: "/addPurchaseQuotation",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseQuotation.tpl.html",
                        controller: "addPurchaseQuotationController",
                    })

                    .state("editPurchaseQuotation", {
                        url: "/editPurchaseQuotation/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseQuotation.tpl.html",
                        controller: "addPurchaseQuotationController",
                    })

                    .state("linkPurchaseQuotation", {
                        url: "/linkPurchaseQuotation/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseQuotation.tpl.html",
                        controller: "addPurchaseQuotationController",
                    })

                    .state("viewPurchaseQuotation", {
                        url: "/viewPurchaseQuotation/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewPurchaseQuotation.tpl.html",
                        controller: "viewPurchaseQuotationController",
                    })

                    .state("approvalPurchaseQuotation", {
                        url: "/approvalPurchaseQuotation",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalPurchaseQuotation.tpl.html",
                        controller: "approvalPurchaseQuotationController",
                    })


                    .state("PurchaseOrder", {
                        url: "/PurchaseOrder",
                        parent: "init",
                        templateUrl: "Templates/purchase/PurchaseOrder.tpl.html",
                        controller: "PurchaseOrderController",
                    })


                    .state("addPurchaseOrder", {
                        url: "/addPurchaseOrder",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseOrder.tpl.html",
                        controller: "addPurchaseOrderController",
                    })

                    .state("editPurchaseOrder", {
                        url: "/editPurchaseOrder/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseOrder.tpl.html",
                        controller: "addPurchaseOrderController",
                    })

                    .state("linkPurchaseOrder", {
                        url: "/linkPurchaseOrder/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseOrder.tpl.html",
                        controller: "addPurchaseOrderController",
                    })

                    .state("viewPurchaseOrder", {
                        url: "/viewPurchaseOrder/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewPurchaseOrder.tpl.html",
                        controller: "viewPurchaseOrderController",
                    })

                    .state("approvalPurchaseOrder", {
                        url: "/approvalPurchaseOrder",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalPurchaseOrder.tpl.html",
                        controller: "approvalPurchaseOrderController",
                    })

                    .state("GoodsReceived", {
                        url: "/GoodsReceived",
                        parent: "init",
                        templateUrl: "Templates/purchase/GoodsReceived.tpl.html",
                        controller: "GoodsReceivedController",
                    })

                    .state("addGoodsReceived", {
                        url: "/addGoodsReceived",
                        parent: "init",
                        templateUrl: "Templates/purchase/addGoodsReceived.tpl.html",
                        controller: "addGoodsReceivedController",
                    })

                    .state("editGoodsReceived", {
                        url: "/editGoodsReceived/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addGoodsReceived.tpl.html",
                        controller: "addGoodsReceivedController",
                    })

                    .state("linkGoodsReceived", {
                        url: "/linkGoodsReceived/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addGoodsReceived.tpl.html",
                        controller: "addGoodsReceivedController",
                    })

                    .state("viewGoodsReceived", {
                        url: "/viewGoodsReceived/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewGoodsReceived.tpl.html",
                        controller: "viewGoodsReceivedController",
                    })



                    .state("approvalGoodsReceived", {
                        url: "/approvalGoodsReceived",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalGoodsReceived.tpl.html",
                        controller: "approvalGoodsReceivedController",
                    })


                    .state("PurchaseInvoice", {
                        url: "/PurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/PurchaseInvoice.tpl.html",
                        controller: "PurchaseInvoiceController",
                    })

                    .state("approvalPurchaseInvoice", {
                        url: "/approvalPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalPurchaseInvoice.tpl.html",
                        controller: "approvalPurchaseInvoiceController",
                    })

                    .state("addPurchaseInvoice", {
                        url: "/addPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseInvoice.tpl.html",
                        controller: "addPurchaseInvoiceController",
                    })

                    .state("editPurchaseInvoice", {
                        url: "/editPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseInvoice.tpl.html",
                        controller: "addPurchaseInvoiceController",
                    })

                    .state("linkPurchaseInvoice", {
                        url: "/linkPurchaseInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseInvoice.tpl.html",
                        controller: "addPurchaseInvoiceController",
                    })

                    .state("viewPurchaseInvoice", {
                        url: "/viewPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewPurchaseInvoice.tpl.html",
                        controller: "viewPurchaseInvoiceController",
                    })

                    .state("ImpPurchaseInvoice", {
                        url: "/ImpPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/ImpPurchaseInvoice.tpl.html",
                        controller: "ImpPurchaseInvoiceController",
                    })

                    .state("addImpPurchaseInvoice", {
                        url: "/addImpPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/addImpPurchaseInvoice.tpl.html",
                        controller: "addImpPurchaseInvoiceController",
                    })

                    .state("editImpPurchaseInvoice", {
                        url: "/editImpPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addImpPurchaseInvoice.tpl.html",
                        controller: "addImpPurchaseInvoiceController",
                    })

                    .state("linkImpPurchaseInvoice", {
                        url: "/linkImpPurchaseInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addImpPurchaseInvoice.tpl.html",
                        controller: "addImpPurchaseInvoiceController",
                    })

                    .state("viewImpPurchaseInvoice", {
                        url: "/viewImpPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewImpPurchaseInvoice.tpl.html",
                        controller: "viewImpPurchaseInvoiceController",
                    })

                    .state("approvalImpPurchaseInvoice", {
                        url: "/approvalImpPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalImpPurchaseInvoice.tpl.html",
                        controller: "approvalImpPurchaseInvoiceController",
                    })

                    .state("ExpPurchaseInvoice", {
                        url: "/ExpPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/ExpPurchaseInvoice.tpl.html",
                        controller: "ExpPurchaseInvoiceController",
                    })

                    .state("addExpPurchaseInvoice", {
                        url: "/addExpPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/addExpPurchaseInvoice.tpl.html",
                        controller: "addExpPurchaseInvoiceController",
                    })

                    .state("editExpPurchaseInvoice", {
                        url: "/editExpPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addExpPurchaseInvoice.tpl.html",
                        controller: "addExpPurchaseInvoiceController",
                    })

                    .state("linkExpPurchaseInvoice", {
                        url: "/linkExpPurchaseInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addExpPurchaseInvoice.tpl.html",
                        controller: "addExpPurchaseInvoiceController",
                    })

                    .state("viewExpPurchaseInvoice", {
                        url: "/viewExpPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewExpPurchaseInvoice.tpl.html",
                        controller: "viewExpPurchaseInvoiceController",
                    })


                    .state("approvalExpPurchaseInvoice", {
                        url: "/approvalExpPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalExpPurchaseInvoice.tpl.html",
                        controller: "approvalExpPurchaseInvoiceController",
                    })

                    .state("DirPurchaseInvoice", {
                        url: "/DirPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/DirPurchaseInvoice.tpl.html",
                        controller: "DirPurchaseInvoiceController",
                    })

                    .state("addDirPurchaseInvoice", {
                        url: "/addDirPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/addDirPurchaseInvoice.tpl.html",
                        controller: "addDirPurchaseInvoiceController",
                    })

                    .state("editDirPurchaseInvoice", {
                        url: "/editDirPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addDirPurchaseInvoice.tpl.html",
                        controller: "addDirPurchaseInvoiceController",
                    })

                    .state("linkDirPurchaseInvoice", {
                        url: "/linkDirPurchaseInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addDirPurchaseInvoice.tpl.html",
                        controller: "addDirPurchaseInvoiceController",
                    })

                    .state("viewDirPurchaseInvoice", {
                        url: "/viewDirPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewDirPurchaseInvoice.tpl.html",
                        controller: "viewDirPurchaseInvoiceController",
                    })

                    .state("approvalDirPurchaseInvoice", {
                        url: "/approvalDirPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalDirPurchaseInvoice.tpl.html",
                        controller: "approvalDirPurchaseInvoiceController",
                    })

                    .state("IndPurchaseInvoice", {
                        url: "/IndPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/IndPurchaseInvoice.tpl.html",
                        controller: "IndPurchaseInvoiceController",
                    })

                    .state("addIndPurchaseInvoice", {
                        url: "/addIndPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/addIndPurchaseInvoice.tpl.html",
                        controller: "addIndPurchaseInvoiceController",
                    })

                    .state("editIndPurchaseInvoice", {
                        url: "/editIndPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addIndPurchaseInvoice.tpl.html",
                        controller: "addIndPurchaseInvoiceController",
                    })

                    .state("linkIndPurchaseInvoice", {
                        url: "/linkIndPurchaseInvoice/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addIndPurchaseInvoice.tpl.html",
                        controller: "addIndPurchaseInvoiceController",
                    })

                    .state("viewIndPurchaseInvoice", {
                        url: "/viewIndPurchaseInvoice/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewIndPurchaseInvoice.tpl.html",
                        controller: "viewIndPurchaseInvoiceController",
                    })

                    .state("approvalIndPurchaseInvoice", {
                        url: "/approvalIndPurchaseInvoice",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalIndPurchaseInvoice.tpl.html",
                        controller: "approvalIndPurchaseInvoiceController",
                    })

                    .state("PurchaseReturn", {
                        url: "/PurchaseReturn",
                        parent: "init",
                        templateUrl: "Templates/purchase/PurchaseReturn.tpl.html",
                        controller: "PurchaseReturnController",
                    })

                    .state("addPurchaseReturn", {
                        url: "/addPurchaseReturn",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseReturn.tpl.html",
                        controller: "addPurchaseReturnController",
                    })

                    .state("editPurchaseReturn", {
                        url: "/editPurchaseReturn/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseReturn.tpl.html",
                        controller: "addPurchaseReturnController",
                    })

                    .state("linkPurchaseReturn", {
                        url: "/linkPurchaseReturn/:LinkVoucherId/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/purchase/addPurchaseReturn.tpl.html",
                        controller: "addPurchaseReturnController",
                    })

                    .state("viewPurchaseReturn", {
                        url: "/viewPurchaseReturn/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/purchase/viewPurchaseReturn.tpl.html",
                        controller: "viewPurchaseReturnController",
                    })

                    .state("approvalPurchaseReturn", {
                        url: "/approvalPurchaseReturn",
                        parent: "init",
                        templateUrl: "Templates/purchase/approvalPurchaseReturn.tpl.html",
                        controller: "approvalPurchaseReturnController",
                    })


                    ///////////////////////////// end purchase ///////////////////////////

                    ///////////////////////////// reprots ///////////////////////////

                    ///////////////////////////// POS reprots ///////////////////////////


                    .state("POSReports", {
                        url: "/POSReports",
                        parent: "init",
                        templateUrl: "Templates/reports/POS/POSReports.tpl.html",
                        //                        controller: "salesReportController",
                    })

                    .state("POSSalesSummaryReport", {
                        url: "/POSSalesSummaryReport",
                        parent: "init",
                        templateUrl: "Templates/reports/pos/POSSalesSummaryReport.tpl.html",
                        controller: "POSSalesSummaryReportController",
                    })
                    .state("POSSalesDetailReport", {
                        url: "/POSSalesDetailReport",
                        parent: "init",
                        templateUrl: "Templates/reports/pos/POSSalesDetailReport.tpl.html",
                        controller: "POSSalesDetailReportController",
                    })
                    .state("employeeWisePosReport", {
                        url: "/employeeWisePosReport",
                        parent: "init",
                        templateUrl: "Templates/reports/pos/employeeWisePosReport.tpl.html",
                        controller: "employeeWisePosReportController",
                    })
                    .state("warehouseWisePosReport", {
                        url: "/warehouseWisePosReport",
                        parent: "init",
                        templateUrl: "Templates/reports/pos/warehouseWisePosReport.tpl.html",
                        controller: "warehouseWisePosReportController",
                    })

                    ///////////////////////////// sales reprots ///////////////////////////

                    .state("salesInvoiceReport", {
                        url: "/salesInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesInvoiceReport.tpl.html",
                        controller: "salesInvoiceReportController",
                    })


                    .state("salesEnquiryReport", {
                        url: "/salesEnquiryReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesEnquiryReport.tpl.html",
                        controller: "salesEnquiryReportController",
                    })


                    .state("creditNoteSRReport", {
                        url: "/creditNoteSRReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/creditNoteSRReport.tpl.html",
                        controller: "creditNoteSRReportController",
                    })

                    .state("packingListReport", {
                        url: "/packingListReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/packingListReport.tpl.html",
                        controller: "packingListReportController",
                    })
                    .state("salesQuotationReport", {
                        url: "/salesQuotationReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesQuotationReport.tpl.html",
                        controller: "salesQuotationReportController",
                    })
                    .state("salesOrderReport", {
                        url: "/salesOrderReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesOrderReport.tpl.html",
                        controller: "salesOrderReportController",
                    })
                    .state("deliveryNoteReport", {
                        url: "/deliveryNoteReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/deliveryNoteReport.tpl.html",
                        controller: "deliveryNoteReportController",
                    })
                    .state("dirSalesInvoiceReport", {
                        url: "/dirSalesInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/dirSalesInvoiceReport.tpl.html",
                        controller: "dirSalesInvoiceReportController",
                    })
                    .state("expSalesInvoiceReport", {
                        url: "/expSalesInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/expSalesInvoiceReport.tpl.html",
                        controller: "expSalesInvoiceReportController",
                    })
                    .state("indSalesInvoiceReport", {
                        url: "/indSalesInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/indSalesInvoiceReport.tpl.html",
                        controller: "indSalesInvoiceReportController",
                    })
                    .state("porfomaInvoiceReport", {
                        url: "/porfomaInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/porfomaInvoiceReport.tpl.html",
                        controller: "porfomaInvoiceReportController",
                    })
                    .state("salesReturnReport", {
                        url: "/salesReturnReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesReturnReport.tpl.html",
                        controller: "salesReturnReportController",
                    })
                    .state("overdueDirSlsInvRpt", {
                        url: "/overdueDirSlsInvRpt/",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/overdueDirSlsInvRpt.tpl.html",
                        controller: "overdueDirSlsInvRptController",
                    })
                    .state("overdueExpSlsInvReport", {
                        url: "/overdueExpSlsInvReport/",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/overdueExpSlsInvReport.tpl.html",
                        controller: "overdueExpSlsInvReportController",
                    })
                    .state("overdueIndSlsInvReport", {
                        url: "/overdueIndSlsInvReport/",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/overdueIndSlsInvReport.tpl.html",
                        controller: "overdueIndSlsInvReportController",
                    })
                    .state("overdueSalesInvReport", {
                        url: "/overdueSalesInvReport/",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/overdueSalesInvReport.tpl.html",
                        controller: "overdueSalesInvReportController",
                    })



                    .state("salesReport", {
                        url: "/salesReport",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesReport.tpl.html",
                        //                        controller: "salesReportController",
                    })
                    .state("pendingSalesReport", {
                        url: "/pendingSalesReport",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/pendingSalesReport.tpl.html",
                        //                        controller: "salesReportController",
                    })
                    .state("mostSellingItems", {
                        url: "/mostSellingItems",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/mostSellingItems.tpl.html",
                        controller: "mostSellingItemsController",
                    })

                    .state("lessSellingItems", {
                        url: "/lessSellingItems",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/lessSellingItems.tpl.html",
                        controller: "lessSellingItemsController",
                    })

                    ///////////////////////////// purchase reprots ///////////////////////////

                    .state("purchaseRequestReport", {
                        url: "/purchaseRequestReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/purchaseRequestReport.tpl.html",
                        controller: "purchaseRequestReportController",
                    })
                    .state("materialRequestReport", {
                        url: "/materialRequestReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/materialRequestReport.tpl.html",
                        controller: "materialRequestReportController",
                    })

                    .state("purchaseEnquiryReport", {
                        url: "/purchaseEnquiryReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/purchaseEnquiryReport.tpl.html",
                        controller: "purchaseEnquiryReportController",
                    })
                    .state("purchaseQuotationReport", {
                        url: "/purchaseQuotationReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/purchaseQuotationReport.tpl.html",
                        controller: "purchaseQuotationReportController",
                    })
                    .state("purchaseOrderReport", {
                        url: "/purchaseOrderReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/purchaseOrderReport.tpl.html",
                        controller: "purchaseOrderReportController",
                    })
                    .state("purchaseInvoiceReport", {
                        url: "/purchaseInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/purchaseInvoiceReport.tpl.html",
                        controller: "purchaseInvoiceReportController",
                    })
                    .state("dirPurchaseInvoiceReport", {
                        url: "/dirPurchaseInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/dirPurchaseInvoiceReport.tpl.html",
                        controller: "dirPurchaseInvoiceReportController",
                    })
                    .state("impPurchaseInvoiceReport", {
                        url: "/impPurchaseInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/impPurchaseInvoiceReport.tpl.html",
                        controller: "impPurchaseInvoiceReportController",
                    })
                    .state("indPurchaseInvoiceReport", {
                        url: "/indPurchaseInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/indPurchaseInvoiceReport.tpl.html",
                        controller: "indPurchaseInvoiceReportController",
                    })
                    .state("expPurchaseInvoiceReport", {
                        url: "/expPurchaseInvoiceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/expPurchaseInvoiceReport.tpl.html",
                        controller: "expPurchaseInvoiceReportController",
                    })
                    .state("PurchaseReturnReport", {
                        url: "/PurchaseReturnReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/PurchaseReturnReport.tpl.html",
                        controller: "PurchaseReturnReportController",
                    })
                    .state("GoodsReceivedReport", {
                        url: "/GoodsReceivedReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/GoodsReceivedReport.tpl.html",
                        controller: "GoodsReceivedReportController",
                    })

                    .state("pendingPurchaseReport", {
                        url: "/pendingPurchaseReport",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/pendingPurchaseReport.tpl.html",
                        //                        controller: "salesReportController",
                    })
                    .state("purchaseReport", {
                        url: "/purchaseReport",
                        parent: "init",
                        templateUrl: "Templates/reports/purchase/purchaseReport.tpl.html",
                        //                        controller: "purchaseReportController",
                    })





                    /////////////////////////////  other sales reports ///////////////////////////

                    .state("othersSalesReport", {
                        url: "/othersSalesReport",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/othersSalesReport.tpl.html",
                        //                        controller: "salesReportController",
                    })

                    .state("salesEnquiry2Report", {
                        url: "/salesEnquiry2Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesEnquiry2Report.tpl.html",
                        controller: "salesEnquiry2ReportController",
                    })

                    .state("salesEnquiry3Report", {
                        url: "/salesEnquiry3Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesEnquiry3Report.tpl.html",
                        controller: "salesEnquiry3ReportController",
                    })

                    .state("salesEnquiry4Report", {
                        url: "/salesEnquiry4Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesEnquiry4Report.tpl.html",
                        controller: "salesEnquiry4ReportController",
                    })

                    .state("salesQuotation2Report", {
                        url: "/salesQuotation2Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesQuotation2Report.tpl.html",
                        controller: "salesQuotation2ReportController",
                    })

                    .state("salesQuotation3Report", {
                        url: "/salesQuotation3Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesQuotation3Report.tpl.html",
                        controller: "salesQuotation3ReportController",
                    })

                    .state("salesQuotation4Report", {
                        url: "/salesQuotation4Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesQuotation4Report.tpl.html",
                        controller: "salesQuotation4ReportController",
                    })

                    .state("salesOrder2Report", {
                        url: "/salesOrder2Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesOrder2Report.tpl.html",
                        controller: "salesOrder2ReportController",
                    })

                    .state("salesOrder3Report", {
                        url: "/salesOrder3Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesOrder3Report.tpl.html",
                        controller: "salesOrder3ReportController",
                    })

                    .state("salesOrder4Report", {
                        url: "/salesOrder4Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesOrder4Report.tpl.html",
                        controller: "salesOrder4ReportController",
                    })

                    .state("deliveryNote2Report", {
                        url: "/deliveryNote2Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/deliveryNote2Report.tpl.html",
                        controller: "deliveryNote2ReportController",
                    })

                    .state("deliveryNote3Report", {
                        url: "/deliveryNote3Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/deliveryNote3Report.tpl.html",
                        controller: "deliveryNote3ReportController",
                    })

                    .state("deliveryNote4Report", {
                        url: "/deliveryNote4Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/deliveryNote4Report.tpl.html",
                        controller: "deliveryNote4ReportController",
                    })

                    .state("salesInvoice2Report", {
                        url: "/salesInvoice2Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesInvoice2Report.tpl.html",
                        controller: "salesInvoice2ReportController",
                    })


                    .state("salesInvoice3Report", {
                        url: "/salesInvoice3Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesInvoice3Report.tpl.html",
                        controller: "salesInvoice3ReportController",
                    })


                    .state("salesInvoice4Report", {
                        url: "/salesInvoice4Report/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/sales/salesInvoice4Report.tpl.html",
                        controller: "salesInvoice4ReportController",
                    })






                    /////////////////////////////  overdue reports ///////////////////////////

                    .state("overdueReport", {
                        url: "/overdueReport",
                        parent: "init",
                        templateUrl: "Templates/reports/overdueReport.tpl.html",
                        //                        controller: "paymentsAndReceiptReportController",
                    })





                    /////////////////////////////  customer reports ///////////////////////////

                    .state("customerReport", {
                        url: "/customerReport",
                        parent: "init",
                        templateUrl: "Templates/reports/customer/customerReport.tpl.html",
                        //                        controller: "paymentsAndReceiptReportController",
                    })

                    .state("customerWiseSalesReport", {
                        url: "/customerWiseSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/customer/customerWiseSalesReport.tpl.html",
                        controller: "customerWiseSalesReportController",
                    })


                    .state("customerWiseDirSalesReport", {
                        url: "/customerWiseDirSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/customer/customerWiseDirSalesReport.tpl.html",
                        controller: "customerWiseDirSalesReportController",
                    })

                    .state("customerWiseIndSalesReport", {
                        url: "/customerWiseIndSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/customer/customerWiseIndSalesReport.tpl.html",
                        controller: "customerWiseIndSalesReportController",
                    })



                    .state("customerWiseExpSalesReport", {
                        url: "/customerWiseExpSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/customer/customerWiseExpSalesReport.tpl.html",
                        controller: "customerWiseExpSalesReportController",
                    })


                    .state("customerWiseProSalesReport", {
                        url: "/customerWiseProSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/customer/customerWiseProSalesReport.tpl.html",
                        controller: "customerWiseProSalesReportController",
                    })


                    /////////////////////////////  operations reports ///////////////////////////

                    .state("operationReport", {
                        url: "/operationReport",
                        parent: "init",
                        templateUrl: "Templates/reports/operations/operationReport.tpl.html",
                    })

                    .state("timesheetReport", {
                        url: "/timesheetReport",
                        parent: "init",
                        templateUrl: "Templates/reports/operations/timesheetReport.tpl.html",
                        controller: "timesheetReportController",
                    })

                    .state("workOrderPendingReport", {
                        url: "/workOrderPendingReport",
                        parent: "init",
                        templateUrl: "Templates/reports/operations/workOrderPendingReport.tpl.html",
                        controller: "workOrderPendingReportController",
                    })

                    .state("adspentReport", {
                        url: "/adspentReport",
                        parent: "init",
                        templateUrl: "Templates/reports/operations/adspentReport.tpl.html",
                        controller: "adspentReportController",
                    })



                    /////////////////////////////  Vendor reports ///////////////////////////

                    .state("vendorReport", {
                        url: "/vendorReport",
                        parent: "init",
                        templateUrl: "Templates/reports/vendor/vendorReport.tpl.html",
                        //                        controller: "paymentsAndReceiptReportController",
                    })


                    .state("vendorWisePurchaseReport", {
                        url: "/vendorWisePurchaseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/vendor/vendorWisePurchaseReport.tpl.html",
                        controller: "vendorWisePurchaseReportController",
                    })


                    .state("VendorWiseDirPurchaseReport", {
                        url: "/VendorWiseDirPurchaseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/vendor/VendorWiseDirPurchaseReport.tpl.html",
                        controller: "VendorWiseDirPurchaseReportController",
                    })



                    .state("vendorWiseImpPurchaseReport", {
                        url: "/vendorWiseImpPurchaseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/vendor/vendorWiseImpPurchaseReport.tpl.html",
                        controller: "vendorWiseImpPurchaseReportController",
                    })


                    .state("vendorWiseIndPurchaseReport", {
                        url: "/vendorWiseIndPurchaseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/vendor/vendorWiseIndPurchaseReport.tpl.html",
                        controller: "vendorWiseIndPurchaseReportController",
                    })



                    /////////////////////////////  product reports ///////////////////////////



                    .state("productReport", {
                        url: "/productReport",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productReport.tpl.html",
                        //                        controller: "paymentsAndReceiptReportController",
                    })

                    .state("productWisePurchaseReport", {
                        url: "/productWisePurchaseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWisePurchaseReport.tpl.html",
                        controller: "productWisePurchaseReportController",
                    })

                    .state("productWiseSalesReport", {
                        url: "/productWiseSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWiseSalesReport.tpl.html",
                        controller: "productWiseSalesReportController",
                    })

                    .state("productWiseDirSalesReport", {
                        url: "/productWiseDirSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWiseDirSalesReport.tpl.html",
                        controller: "productWiseDirSalesReportController",
                    })

                    .state("productWiseIndSalesReport", {
                        url: "/productWiseIndSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWiseIndSalesReport.tpl.html",
                        controller: "productWiseIndSalesReportController",
                    })


                    .state("productWiseExpSalesReport", {
                        url: "/productWiseExpSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWiseExpSalesReport.tpl.html",
                        controller: "productWiseExpSalesReportController",
                    })


                    .state("productWiseProSalesReport", {
                        url: "/productWiseProSalesReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWiseProSalesReport.tpl.html",
                        controller: "productWiseProSalesReportController",
                    })

                    .state("productWiseDirPurchaseReport", {
                        url: "/productWiseDirPurchaseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWiseDirPurchaseReport.tpl.html",
                        controller: "productWiseDirPurchaseReportController",
                    })

                    .state("productWiseImpPurchaseReport", {
                        url: "/productWiseImpPurchaseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWiseImpPurchaseReport.tpl.html",
                        controller: "productWiseImpPurchaseReportController",
                    })

                    .state("productWiseIndPurchaseReport", {
                        url: "/productWiseIndPurchaseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productWiseIndPurchaseReport.tpl.html",
                        controller: "productWiseIndPurchaseReportController",
                    })

                    .state("purchaseQueue", {
                        url: "/purchaseQueue",
                        parent: "init",
                        templateUrl: "Templates/reports/product/purchaseQueue.tpl.html",
                        controller: "purchaseQueueController",
                    })

                    .state("productSeries", {
                        url: "/productSeries",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productSeries.tpl.html",
                        controller: "productSeriesController",
                    })

                    .state("productForcasiting", {
                        url: "/productForcasiting",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productForcasiting.tpl.html",
                        controller: "productForcasitingController",
                    })

                    .state("productQuery", {
                        url: "/productQuery",
                        parent: "init",
                        templateUrl: "Templates/reports/product/productQuery.tpl.html",
                        controller: "productQueryController",
                    })


                    /////////////////////////////  pay rec reprots ///////////////////////////

                    .state("paymentsAndReceiptReport", {
                        url: "/paymentsAndReceiptReport",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/paymentsAndReceiptReport.tpl.html",
                        //                        controller: "paymentsAndReceiptReportController",
                    })
                    .state("openingBalanceReport", {
                        url: "/openingBalanceReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/openingBalanceReport.tpl.html",
                        controller: "openingBalanceReportController",
                    })
                    .state("journalVoucherReport", {
                        url: "/journalVoucherReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/journalVoucherReport.tpl.html",
                        controller: "journalVoucherReportController",
                    })
                    .state("creditNoteReport", {
                        url: "/creditNoteReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/creditNoteReport.tpl.html",
                        controller: "creditNoteReportController",
                    })
                    .state("debitNoteReport", {
                        url: "/debitNoteReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/debitNoteReport.tpl.html",
                        controller: "debitNoteReportController",
                    })
                    .state("companyExpenseReport", {
                        url: "/companyExpenseReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/companyExpenseReport.tpl.html",
                        controller: "companyExpenseReportController",
                    })
                    .state("chequeReceiptReport", {
                        url: "/chequeReceiptReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/chequeReceiptReport.tpl.html",
                        controller: "chequeReceiptReportController",
                    })
                    .state("fundReceiptReport", {
                        url: "/fundReceiptReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/fundReceiptReport.tpl.html",
                        controller: "fundReceiptReportController",
                    })
                    .state("cashPaymentReport", {
                        url: "/cashPaymentReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/cashPaymentReport.tpl.html",
                        controller: "cashPaymentReportController",
                    })
                    .state("paymentReport", {
                        url: "/paymentReport",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/paymentReport.tpl.html",
                        controller: "paymentReportController",
                    })
                    .state("receiptReport", {
                        url: "/receiptReport",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/receiptReport.tpl.html",
                        controller: "receiptReportController",
                    })
                    .state("cashReceiptReport", {
                        url: "/cashReceiptReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/cashReceiptReport.tpl.html",
                        controller: "cashReceiptReportController",
                    })
                    .state("chequePaymentReport", {
                        url: "/chequePaymentReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/chequePaymentReport.tpl.html",
                        controller: "chequePaymentReportController",
                    })
                    .state("fundPaymentReport", {
                        url: "/fundPaymentReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/payrec/fundPaymentReport.tpl.html",
                        controller: "fundPaymentReportController",
                    })

                    /////////////////////////////   rec pay reprots ///////////////////////////

                    .state("receivablesPayablesReport", {
                        url: "/receivablesPayablesReport",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/receivablesPayablesReport.tpl.html",
                        //                        controller: "purchaseReportController",
                    })
                    .state("billwiseReport", {
                        url: "/billwiseReport",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/billwiseReport.tpl.html",
                        controller: "billwiseReportController",
                    })
                    .state("billAdjustmentReport", {
                        url: "/billAdjustmentReport",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/billAdjustmentReport.tpl.html",
                        controller: "billAdjustmentReportController",
                    })
                    .state("billwiseAnalysis", {
                        url: "/billwiseAnalysis",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/billwiseAnalysis.tpl.html",
                        controller: "billwiseAnalysisController",
                    })
                    .state("billwiseOutstanding", {
                        url: "/billwiseOutstanding",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/billwiseOutstanding.tpl.html",
                        controller: "billwiseOutstandingController",
                    })
                    .state("listofoutstandingCredit", {
                        url: "/listofoutstandingCredit",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/listofoutstandingCredit.tpl.html",
                        controller: "listofoutstandingCreditController",
                    })
                    .state("listofoutstandingDebit", {
                        url: "/listofoutstandingDebit",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/listofoutstandingDebit.tpl.html",
                        controller: "listofoutstandingDebitController",
                    })
                    .state("BillwiseAging", {
                        url: "/BillwiseAging",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/BillwiseAging.tpl.html",
                        controller: "BillwiseAgingController",
                    })
                    .state("AgingAnalysis", {
                        url: "/AgingAnalysis",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/AgingAnalysis.tpl.html",
                        controller: "AgingAnalysisController",
                    })
                    .state("agingAnalysisSummary", {
                        url: "/agingAnalysisSummary",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/agingAnalysisSummary.tpl.html",
                        controller: "agingAnalysisSummaryController",
                    })
                    .state("AgingAnalysisCreditors", {
                        url: "/AgingAnalysisCreditors",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/AgingAnalysisCreditors.tpl.html",
                        controller: "AgingAnalysisCreditorsController",
                    })
                    .state("AgingAnalysisDebtors", {
                        url: "/AgingAnalysisDebtors",
                        parent: "init",
                        templateUrl: "Templates/reports/recpay/AgingAnalysisDebtors.tpl.html",
                        controller: "AgingAnalysisDebtorsController",
                    })



                    /////////////////////////////   stock reprots ///////////////////////////


                    .state("inventoryReport", {
                        url: "/inventoryReport",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/inventoryReport.tpl.html",
                    })

                    .state("stockLedger", {
                        url: "/stockLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockLedger.tpl.html",
                        controller: "stockLedgerController",
                    })

                    .state("stockLedgerSummary", {
                        url: "/stockLedgerSummary",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockLedger.tpl.html",
                        controller: "stockLedgerSummaryController",
                    })

                    .state("warehouseLedger", {
                        url: "/warehouseLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/warehouseLedger.tpl.html",
                        controller: "warehouseLedgerController",
                    })

                    .state("warehouseStockList", {
                        url: "/warehouseStockList/:Level",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/warehouseStockList.tpl.html",
                        controller: "warehouseStockListController",
                    })

                    .state("stockLedgerMU", {
                        url: "/stockLedgerMU",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockLedgerMU.tpl.html",
                        controller: "stockLedgerMUController",
                    })

                    .state("stockList", {
                        url: "/stockList",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockList.tpl.html",
                        controller: "stockListController",
                    })

                    .state("stockValuation", {
                        url: "/stockValuation",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockValuation.tpl.html",
                        controller: "stockValuationController",
                    })

                    .state("warehouseStockValuation", {
                        url: "/warehouseStockValuation/:Level",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/warehouseStockValuation.tpl.html",
                        controller: "warehouseStockValuationController",
                    })

                    .state("stockMovement", {
                        url: "/stockMovement",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockMovement.tpl.html",
                        controller: "stockMovementController",
                    })

                    .state("batchLedger", {
                        url: "/batchLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/batchLedger.tpl.html",
                        controller: "batchLedgerController",
                    })


                    .state("openingStockReport", {
                        url: "/openingStockReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/openingStockReport.tpl.html",
                        controller: "openingStockReportController",
                    })


                    .state("stockIssueReport", {
                        url: "/stockIssueReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockIssueReport.tpl.html",
                        controller: "stockIssueReportController",
                    })

                    .state("stockFOCReport", {
                        url: "/stockFOCReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockFOCReport.tpl.html",
                        controller: "stockFOCReportController",
                    })


                    .state("stockReceiveReport", {
                        url: "/stockReceiveReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockReceiveReport.tpl.html",
                        controller: "stockReceiveReportController",
                    })

                    .state("stockJVReport", {
                        url: "/stockJVReport/:Type",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockJVReport.tpl.html",
                        controller: "stockJVReportController",
                    })


                    .state("reorderReport", {
                        url: "/reorderReport",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/reorderReport.tpl.html",
                        controller: "reorderReportController",
                    })

                    .state("stockReserveReport", {
                        url: "/stockReserveReport",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/stockReserveReport.tpl.html",
                        controller: "stockReserveReportController",
                    })

                    .state("productWiseAging", {
                        url: "/productWiseAging",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/productWiseAging.tpl.html",
                        controller: "productWiseAgingController",
                    })

                    .state("productDetailedList", {
                        url: "/productDetailedList",
                        parent: "init",
                        templateUrl: "Templates/reports/stock/productDetailedList.tpl.html",
                        controller: "productDetailedListController",
                    })


                    /////////////////////////////   other reprots ///////////////////////////

                    .state("LinkReport", {
                        url: "/LinkReport",
                        parent: "init", 
                        templateUrl: "Templates/reports/LinkReport.tpl.html",
                        controller: "LinkReportController",
                    })

                    .state("JobWiseProfit", {
                        url: "/JobWiseProfit",
                        parent: "init",
                        templateUrl: "Templates/reports/JobWiseProfit.tpl.html",
                        controller: "JobWiseProfitController",
                    })

                    .state("JobWiseProfitDetails", {
                        url: "/JobWiseProfitDetails",
                        parent: "init",
                        templateUrl: "Templates/reports/JobWiseProfitDetails.tpl.html",
                        controller: "JobWiseProfitDetailsController",
                    })

                    .state("ProjectWiseProfit", {
                        url: "/ProjectWiseProfit",
                        parent: "init",
                        templateUrl: "Templates/reports/ProjectWiseProfit.tpl.html",
                        controller: "ProjectWiseProfitController",
                    })

                    .state("ProjectWiseProfitDetails", {
                        url: "/ProjectWiseProfitDetails",
                        parent: "init",
                        templateUrl: "Templates/reports/ProjectWiseProfitDetails.tpl.html",
                        controller: "ProjectWiseProfitDetailsController",
                    })

                    .state("financialReport", {
                        url: "/financialReport",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/financialReport.tpl.html",
                    })
                    .state("hrReport", {
                        url: "/hrReport",
                        parent: "init",
                        templateUrl: "Templates/reports/hr/hrReport.tpl.html",
                    })

                    .state("attendanceReport", {
                        url: "/attendanceReport",
                        parent: "init",
                        templateUrl: "Templates/reports/hr/attendanceReport.tpl.html",
                        controller: "attendanceReportController",
                    })

                    .state("leaveMonthlyReport", {
                        url: "/leaveMonthlyReport",
                        parent: "init",
                        templateUrl: "Templates/reports/hr/leaveMonthlyReport.tpl.html",
                        controller: "leaveMonthlyReportController",
                    })

                    .state("leaveAttSumReport", {
                        url: "/leaveAttSumReport",
                        parent: "init",
                        templateUrl: "Templates/reports/hr/leaveAttSumReport.tpl.html",
                        controller: "leaveAttSumReportController",
                    })

                    .state("leaveReport", {
                        url: "/leaveReport",
                        parent: "init",
                        templateUrl: "Templates/reports/hr/leaveReport.tpl.html",
                        controller: "leaveReportController",
                    })

                     .state("paySheetSummaryReport", {
                        url: "/paySheetSummaryReport",
                        parent: "init",
                        templateUrl: "Templates/reports/hr/paySheetSummaryReport.tpl.html",
                        controller: "paySheetSummaryReportController",
                    })

                    .state("leaveReportSummary", {
                        url: "/leaveReportSummary",
                        parent: "init",
                        templateUrl: "Templates/reports/hr/leaveReportSummary.tpl.html",
                        controller: "leaveReportSummaryController",
                    })
                    .state("expiredEmpDocsReport", {
                        url: "/expiredEmpDocsReport",
                        parent: "init",
                        templateUrl: "Templates/reports/hr/expiredEmpDocsReport.tpl.html",
                        controller: "expiredEmpDocsReportController",
                    })

                    .state("generalLedger", {
                        url: "/generalLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/generalLedger.tpl.html",
                        controller: "generalLedgerController",
                    })
                    .state("generalLedgerbyAcc", {
                        url: "/generalLedgerbyAcc/:accId/:datefrom/:dateTo",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/generalLedger.tpl.html",
                        controller: "generalLedgerController",
                    })
                    .state("generalLedger2", {
                        url: "/generalLedger2",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/generalLedger2.tpl.html",
                        controller: "generalLedger2Controller",
                    })
                    .state("generalLedger3", {
                        url: "/generalLedger3",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/generalLedger3.tpl.html",
                        controller: "generalLedger3Controller",
                    })
                    .state("costwiseLedger", {
                        url: "/costwiseLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/costwiseLedger.tpl.html"
                    })
                    .state("profitLoss2", {
                        url: "/profitLoss2",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/profitLoss2.tpl.html"
                    })
                    .state("generalLedgerPDC", {
                        url: "/generalLedgerPDC",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/generalLedgerPDC.tpl.html",
                        controller: "generalLedgerPDCController",
                    })

                    .state("costLedger", {
                        url: "/costLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/costLedger.tpl.html",
                        controller: "costLedgerController",
                    })
                    .state("vatReport", {
                        url: "/vatReport",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/vatReport.tpl.html",
                        controller: "vatReportController",
                    })
                     .state("conflictedLedgers", {
                        url: "/conflictedLedgers",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/conflictedLedgers.tpl.html",
                        controller: "conflictedLedgersController",
                    })

                    .state("counterSalesReport", {
                        url: "/counterSalesReport",
                        parent: "init",
                        templateUrl: "Templates/reports/counterSalesReport.tpl.html",
                        controller: "counterSalesReportController",
                    })

                    .state("assetLedger", {
                        url: "/assetLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/assetLedger.tpl.html",
                        controller: "assetLedgerController",
                    })

                    .state("liabilitiesLedger", {
                        url: "/liabilitiesLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/liabilitiesLedger.tpl.html",
                        controller: "liabilitiesLedgerController",
                    })


                    .state("expenseLedger", {
                        url: "/expenseLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/expenseLedger.tpl.html",
                        controller: "expenseLedgerController",
                    })

                    .state("revenewLedger", {
                        url: "/revenewLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/revenewLedger.tpl.html",
                        controller: "revenewLedgerController",
                    })

                    .state("otherRevenewLedger", {
                        url: "/otherRevenewLedger",
                        parent: "init",
                        templateUrl: "Templates/reports/otherRevenewLedger.tpl.html",
                        controller: "otherRevenewLedgerController",
                    })

                    .state("trailBalance", {
                        url: "/trailBalance",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/trailBalance.tpl.html",
                        controller: "trailBalanceController",
                    })

                    .state("accountBalance", {
                        url: "/accountBalance",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/accountBalance.tpl.html",
                        controller: "accountBalanceController",
                    })

                    .state("assetBalance", {
                        url: "/assetBalance",
                        parent: "init",
                        templateUrl: "Templates/reports/assetBalance.tpl.html",
                        controller: "assetBalanceController",
                    })

                    .state("liabilitiesBalance", {
                        url: "/liabilitiesBalance",
                        parent: "init",
                        templateUrl: "Templates/reports/liabilitiesBalance.tpl.html",
                        controller: "liabilitiesBalanceController",
                    })

                    .state("costBalance", {
                        url: "/costBalance",
                        parent: "init",
                        templateUrl: "Templates/reports/costBalance.tpl.html",
                        controller: "costBalanceController",
                    })

                    .state("expenseBalance", {
                        url: "/expenseBalance",
                        parent: "init",
                        templateUrl: "Templates/reports/expenseBalance.tpl.html",
                        controller: "expenseBalanceController",
                    })

                    .state("revenewBalance", {
                        url: "/revenewBalance",
                        parent: "init",
                        templateUrl: "Templates/reports/revenewBalance.tpl.html",
                        controller: "revenewBalanceController",
                    })

                    .state("otherRevenewBalance", {
                        url: "/otherRevenewBalance",
                        parent: "init",
                        templateUrl: "Templates/reports/otherRevenewBalance.tpl.html",
                        controller: "otherRevenewBalanceController",
                    })

                    .state("profitLoss", {
                        url: "/profitLoss",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/profitLoss.tpl.html",
                        controller: "profitLossController",
                    })

                    .state("balanceSheet", {
                        url: "/balanceSheet",
                        parent: "init",
                        templateUrl: "Templates/reports/financial/balanceSheet.tpl.html",
                        controller: "balanceSheetController",
                    })

                    .state("EmployeeSalesReport", {
                        url: "/EmployeeSalesReport",
                        parent: "init",
                        templateUrl: "Templates/reports/EmployeeSalesReport.tpl.html",
                        controller: "EmployeeSalesReportController",
                    })

                    ///////////////////////////// deleted vouchers ///////////////////////////

                    .state("trashReports", {
                        url: "/trashReports",
                        parent: "init",
                        templateUrl: "Templates/reports/trash/trashReports.tpl.html",
                    })

                    .state("salesVoucherTrash", {
                        url: "/salesVoucherTrash",
                        parent: "init",
                        templateUrl: "Templates/reports/trash/salesVoucherTrash.tpl.html",
                        controller: "salesVoucherTrashController",
                    })

                    .state("otherSalesVoucherTrash", {
                        url: "/otherSalesVoucherTrash",
                        parent: "init",
                        templateUrl: "Templates/reports/trash/otherSalesVoucherTrash.tpl.html",
                        controller: "otherSalesVoucherTrashController",
                    })

                    .state("purchaseVoucherTrash", {
                        url: "/purchaseVoucherTrash",
                        parent: "init",
                        templateUrl: "Templates/reports/trash/purchaseVoucherTrash.tpl.html",
                        controller: "purchaseVoucherTrashController",
                    })

                    .state("payrecVoucherTrash", {
                        url: "/payrecVoucherTrash",
                        parent: "init",
                        templateUrl: "Templates/reports/trash/payrecVoucherTrash.tpl.html",
                        controller: "payrecVoucherTrashController",
                    })

                    .state("stockVoucherTrash", {
                        url: "/stockVoucherTrash",
                        parent: "init",
                        templateUrl: "Templates/reports/trash/stockVoucherTrash.tpl.html",
                        controller: "stockVoucherTrashController",
                    })

                    ///////////////////////////// end report ///////////////////////////


                    ///////////////////////////// Operations ///////////////////////////

                    .state("vehicleAllocation", {
                        url: "/vehicleAllocation",
                        parent: "init",
                        templateUrl: "templates/operations/vehicleAllocation.tpl.html",
                        controller: "vehicleAllocationController",
                    })

                    .state("timeSheets", {
                        url: "/timeSheets",
                        parent: "init",
                        templateUrl: "templates/operations/timeSheets.tpl.html",
                        controller: "timeSheetsController",
                    })

                    .state("addTimesheet", {
                        url: "/addTimesheet",
                        parent: "init",
                        templateUrl: "templates/operations/addTimesheet.tpl.html",
                        controller: "addTimesheetController",
                    })

                    .state("editTimesheet", {
                        url: "/editTimesheet/:VoucherId",
                        parent: "init",
                        templateUrl: "templates/operations/addTimesheet.tpl.html",
                        controller: "addTimesheetController",
                    })

                    .state("customerDriverPayConfig", {
                        url: "/customerDriverPayConfig",
                        parent: "init",
                        templateUrl: "templates/operations/customerDriverPayConfig.tpl.html",
                        controller: "customerDriverPayConfigController",
                    })

                    .state("driverPaymentSheets", {
                        url: "/driverPaymentSheets",
                        parent: "init",
                        templateUrl: "templates/operations/driverPaymentSheets.tpl.html",
                        controller: "driverPaymentSheetsController",
                    })

                    .state("addDriverPaymentSheet", {
                        url: "/addDriverPaymentSheet",
                        parent: "init",
                        templateUrl: "templates/operations/addDriverPaymentSheet.tpl.html",
                        controller: "addDriverPaymentSheetController",
                    })

                    .state("editDriverPaymentSheet", {
                        url: "/editDriverPaymentSheet/:VoucherId",
                        parent: "init",
                        templateUrl: "templates/operations/addDriverPaymentSheet.tpl.html",
                        controller: "addDriverPaymentSheetController",
                    })

                    ///////////////////////////// Cash and receipts ///////////////////////////

                    .state("CPVMaster", {
                        url: "/CPVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/CPVMaster.tpl.html",
                        controller: "CPVMasterController",
                    })

                    .state("ApprovalCPVMaster", {
                        url: "/ApprovalCPVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/ApprovalCPVMaster.tpl.html",
                        controller: "ApprovalCPVMasterController",
                    })


                    .state("addCPVMaster", {
                        url: "/addCPVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/addCPVMaster.tpl.html",
                        controller: "addCPVMasterController",
                    })

                    .state("editCPVMaster", {
                        url: "/editCPVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/addCPVMaster.tpl.html",
                        controller: "addCPVMasterController",
                    })

                    .state("viewCPVMaster", {
                        url: "/viewCPVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/viewCPVMaster.tpl.html",
                        controller: "viewCPVMasterController",
                    })



                    .state("CRVMaster", {
                        url: "/CRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/CRVMaster.tpl.html",
                        controller: "CRVMasterController",
                    })

                     .state("ApprovalCRVMaster", {
                        url: "/ApprovalCRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/ApprovalCRVMaster.tpl.html",
                        controller: "ApprovalCRVMasterController",
                    })



                    .state("addCRVMaster", {
                        url: "/addCRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/addCRVMaster.tpl.html",
                        controller: "addCRVMasterController",
                    })

                    .state("editCRVMaster", {
                        url: "/editCRVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/addCRVMaster.tpl.html",
                        controller: "addCRVMasterController",
                    })

                    .state("viewCRVMaster", {
                        url: "/viewCRVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/viewCRVMaster.tpl.html",
                        controller: "viewCRVMasterController",
                    })




                    .state("FPVMaster", {
                        url: "/FPVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/FPVMaster.tpl.html",
                        controller: "FPVMasterController",
                    })

                     .state("ApprovalFPVMaster", {
                        url: "/ApprovalFPVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/ApprovalFPVMaster.tpl.html",
                        controller: "ApprovalFPVMasterController",
                    })


                    .state("addFPVMaster", {
                        url: "/addFPVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/addFPVMaster.tpl.html",
                        controller: "addFPVMasterController",
                    })

                    .state("editFPVMaster", {
                        url: "/editFPVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/addFPVMaster.tpl.html",
                        controller: "addFPVMasterController",
                    })

                    .state("viewFPVMaster", {
                        url: "/viewFPVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/viewFPVMaster.tpl.html",
                        controller: "viewFPVMasterController",
                    })


                    .state("FRVMaster", {
                        url: "/FRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/FRVMaster.tpl.html",
                        controller: "FRVMasterController",
                    })

                    .state("ApprovalFRVMaster", {
                        url: "/ApprovalFRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/ApprovalFRVMaster.tpl.html",
                        controller: "ApprovalFRVMasterController",
                    })

                    .state("addFRVMaster", {
                        url: "/addFRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/addFRVMaster.tpl.html",
                        controller: "addFRVMasterController",
                    })

                    .state("editFRVMaster", {
                        url: "/editFRVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/addFRVMaster.tpl.html",
                        controller: "addFRVMasterController",
                    })

                    .state("viewFRVMaster", {
                        url: "/viewFRVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/viewFRVMaster.tpl.html",
                        controller: "viewFRVMasterController",
                    })


                    .state("JVMaster", {
                        url: "/JVMaster",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/JVMaster.tpl.html",
                        controller: "JVMasterController",
                    })

                    .state("ApprovalJVMaster", {
                        url: "/ApprovalJVMaster",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/ApprovalJVMaster.tpl.html",
                        controller: "ApprovalJVMasterController",
                    })

                    .state("addJVMaster", {
                        url: "/addJVMaster",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addJVMaster.tpl.html",
                        controller: "addJVMasterController",
                    })

                    .state("editJVMaster", {
                        url: "/editJVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addJVMaster.tpl.html",
                        controller: "addJVMasterController",
                    })

                    .state("viewJVMaster", {
                        url: "/viewJVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/viewJVMaster.tpl.html",
                        controller: "viewJVMasterController",
                    })




                    .state("ApprovalCreditNote", {
                        url: "/ApprovalCreditNote",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/ApprovalCreditNote.tpl.html",
                        controller: "ApprovalCreditNoteController",
                    })

                    .state("CreditNote", {
                        url: "/CreditNote",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/CreditNote.tpl.html",
                        controller: "CreditNoteController",
                    })

                    .state("addCreditNote", {
                        url: "/addCreditNote",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addCreditNote.tpl.html",
                        controller: "addCreditNoteController",
                    })

                    .state("editCreditNote", {
                        url: "/editCreditNote/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addCreditNote.tpl.html",
                        controller: "addCreditNoteController",
                    })

                    .state("viewCreditNote", {
                        url: "/viewCreditNote/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/viewCreditNote.tpl.html",
                        controller: "viewCreditNoteController",
                    })

                    .state("DebitNote", {
                        url: "/DebitNote",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/DebitNote.tpl.html",
                        controller: "DebitNoteController",
                    })

                    .state("ApprovalDebitNote", {
                        url: "/ApprovalDebitNote",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/ApprovalDebitNote.tpl.html",
                        controller: "ApprovalDebitNoteController",
                    })

                    .state("addDebitNote", {
                        url: "/addDebitNote",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addDebitNote.tpl.html",
                        controller: "addDebitNoteController",
                    })

                    .state("editDebitNote", {
                        url: "/editDebitNote/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addDebitNote.tpl.html",
                        controller: "addDebitNoteController",
                    })

                    .state("viewDebitNote", {
                        url: "/viewDebitNote/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/viewDebitNote.tpl.html",
                        controller: "viewDebitNoteController",
                    })



                    .state("companyExpense", {
                        url: "/companyExpense",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/companyExpense.tpl.html",
                        controller: "companyExpenseController",
                    })

                    .state("ApprovalcompanyExpense", {
                        url: "/ApprovalcompanyExpense",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/ApprovalcompanyExpense.tpl.html",
                        controller: "ApprovalcompanyExpenseController",
                    })

                    .state("addcompanyExpense", {
                        url: "/addcompanyExpense",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addcompanyExpense.tpl.html",
                        controller: "addcompanyExpenseController",
                    })

                    .state("editcompanyExpense", {
                        url: "/editcompanyExpense/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addcompanyExpense.tpl.html",
                        controller: "addcompanyExpenseController",
                    })

                    .state("viewcompanyExpense", {
                        url: "/viewcompanyExpense/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/viewcompanyExpense.tpl.html",
                        controller: "viewcompanyExpenseController",
                    })

                    .state("OpeningBalance", {
                        url: "/OpeningBalance",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/OPBalnc.tpl.html",
                        controller: "OPBalncController",
                    })

                    
                    .state("ApprovalOpeningBalance", {
                        url: "/ApprovalOpeningBalance",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/ApprovalOPBalnc.tpl.html",
                        controller: "ApprovalOPBalncController",
                    })

                    .state("addOpeningBalance", {
                        url: "/addOpeningBalance",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addOpeningBalance.tpl.html",
                        controller: "addOpeningBalanceController",
                    })

                    .state("editOpeningBalance", {
                        url: "/editOpeningBalance/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/addOpeningBalance.tpl.html",
                        controller: "addOpeningBalanceController",
                    })

                    .state("viewOpeningBalance", {
                        url: "/viewOpeningBalance/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/basicVouchers/viewOpeningBalance.tpl.html",
                        controller: "viewOpeningBalanceController",
                    })


                    .state("ChequePVMaster", {
                        url: "/ChequePVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/ChequePVMaster.tpl.html",
                        controller: "ChequePVMasterController",
                    })

                    .state("ApprovalChequePVMaster", {
                        url: "/ApprovalChequePVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/ApprovalChequePVMaster.tpl.html",
                        controller: "ApprovalChequePVMasterController",
                    })


                    .state("addChequePVMaster", {
                        url: "/addChequePVMaster",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/addChequePVMaster.tpl.html",
                        controller: "addChequePVMasterController",
                    })

                    .state("editChequePVMaster", {
                        url: "/editChequePVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/addChequePVMaster.tpl.html",
                        controller: "addChequePVMasterController",
                    })

                    .state("viewChequePVMaster", {
                        url: "/viewChequePVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/paymentVouchers/viewChequePVMaster.tpl.html",
                        controller: "viewChequePVMasterController",
                    })

                    .state("ChequeRVMaster", {
                        url: "/ChequeRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/ChequeRVMaster.tpl.html",
                        controller: "ChequeRVMasterController",
                    })

                    .state("ApprovalChequeRVMaster", {
                        url: "/ApprovalChequeRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/ApprovalChequeRVMaster.tpl.html",
                        controller: "ApprovalChequeRVMasterController",
                    })


                    .state("addChequeRVMaster", {
                        url: "/addChequeRVMaster",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/addChequeRVMaster.tpl.html",
                        controller: "addChequeRVMasterController",
                    })

                    .state("editChequeRVMaster", {
                        url: "/editChequeRVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/addChequeRVMaster.tpl.html",
                        controller: "addChequeRVMasterController",
                    })

                    .state("viewChequeRVMaster", {
                        url: "/viewChequeRVMaster/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/receiptVouchers/viewChequeRVMaster.tpl.html",
                        controller: "viewChequeRVMasterController",
                    })


                    ///////////////////////////// End Cash and receipts ///////////////////////////

                    ///////////////////////////// PDC ///////////////////////////

                    .state("PendingPDC", {
                        url: "/PendingPDC",
                        parent: "init",
                        templateUrl: "Templates/pdc/PendingPDC.tpl.html",
                        controller: "PendingPDCController",
                    })

                    .state("ProcessedPDC", {
                        url: "/ProcessedPDC",
                        parent: "init",
                        templateUrl: "Templates/pdc/ProcessedPDC.tpl.html",
                        controller: "ProcessedPDCController",
                    })

                    .state("ReconcileChequePay", {
                        url: "/ReconcileChequePay",
                        parent: "init",
                        templateUrl: "Templates/pdc/ReconcileChequePay.tpl.html",
                        controller: "ReconcileChequePayController",
                    })

                    .state("ReconcileChequeRec", {
                        url: "/ReconcileChequeRec",
                        parent: "init",
                        templateUrl: "Templates/pdc/ReconcileChequeRec.tpl.html",
                        controller: "ReconcileChequeRecController",
                    })

                    .state("BounceChequeRec", {
                        url: "/BounceChequeRec",
                        parent: "init",
                        templateUrl: "Templates/pdc/BounceChequeRec.tpl.html",
                        controller: "BounceChequeRecController",
                    })

                    .state("BounceChequePay", {
                        url: "/BounceChequePay",
                        parent: "init",
                        templateUrl: "Templates/pdc/BounceChequePay.tpl.html",
                        controller: "BounceChequePayController",
                    })

                    ///////////////////////////// end PDC ///////////////////////////

                    ///////////////////////////// Stock ///////////////////////////



                    .state("StockRecieve", {
                        url: "/StockRecive",
                        parent: "init",
                        templateUrl: "Templates/stock/StockRecieve.tpl.html",
                        controller: "StockRecieveController",
                    })

                    .state("ApprovalStockRecieve", {
                        url: "/ApprovalStockRecive",
                        parent: "init",
                        templateUrl: "Templates/stock/ApprovalStockRecieve.tpl.html",
                        controller: "ApprovalStockRecieveController",
                    })

                    .state("addStockRecieve", {
                        url: "/addStockRecieve",
                        parent: "init",
                        templateUrl: "Templates/stock/addStockRecieve.tpl.html",
                        controller: "addStockRecieveController",
                    })

                    .state("editStockRecieve", {
                        url: "/editStockRecieve/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/addStockRecieve.tpl.html",
                        controller: "addStockRecieveController",
                    })

                    .state("viewStockRecieve", {
                        url: "/viewStockRecieve/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/viewStockRecieve.tpl.html",
                        controller: "viewStockRecieveController",
                    })

                    .state("OpeningStock", {
                        url: "/OpeningStock",
                        parent: "init",
                        templateUrl: "Templates/stock/OpeningStock.tpl.html",
                        controller: "OpeningStockController",
                    })

                    .state("ApprovalOpeningStock", {
                        url: "/ApprovalOpeningStock",
                        parent: "init",
                        templateUrl: "Templates/stock/ApprovalOpeningStock.tpl.html",
                        controller: "ApprovalOpeningStockController",
                    })


                    .state("addOpeningStock", {
                        url: "/addOpeningStock",
                        parent: "init",
                        templateUrl: "Templates/stock/addOpeningStock.tpl.html",
                        controller: "addOpeningStockController",
                    })

                    .state("editOpeningStock", {
                        url: "/editOpeningStock/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/addOpeningStock.tpl.html",
                        controller: "addOpeningStockController",
                    })

                    .state("viewOpeningStock", {
                        url: "/viewOpeningStock/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/viewOpeningStock.tpl.html",
                        controller: "viewOpeningStockController",
                    })




                    .state("StockIssue", {
                        url: "/StockIssue",
                        parent: "init",
                        templateUrl: "Templates/stock/StockIssue.tpl.html",
                        controller: "StockIssueController",
                    })

                    .state("ApprovalStockIssue", {
                        url: "/ApprovalStockIssue",
                        parent: "init",
                        templateUrl: "Templates/stock/ApprovalStockIssue.tpl.html",
                        controller: "ApprovalStockIssueController",
                    })

                    .state("addStockIssue", {
                        url: "/addStockIssue",
                        parent: "init",
                        templateUrl: "Templates/stock/addStockIssue.tpl.html",
                        controller: "addStockIssueController",
                    })

                    .state("editStockIssue", {
                        url: "/editStockIssue/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/addStockIssue.tpl.html",
                        controller: "addStockIssueController",
                    })

                    .state("viewStockIssue", {
                        url: "/viewStockIssue/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/viewStockIssue.tpl.html",
                        controller: "viewStockIssueController",
                    })


                    .state("StockJV", {
                        url: "/StockJV",
                        parent: "init",
                        templateUrl: "Templates/stock/StockJV.tpl.html",
                        controller: "StockJVController",
                    })

                    .state("ApprovalStockJV", {
                        url: "/ApprovalStockJV",
                        parent: "init",
                        templateUrl: "Templates/stock/ApprovalStockJV.tpl.html",
                        controller: "ApprovalStockJVController",
                    })

                    .state("addStockJV", {
                        url: "/addStockJV",
                        parent: "init",
                        templateUrl: "Templates/stock/addStockJV.tpl.html",
                        controller: "addStockJVController",
                    })

                    .state("editStockJV", {
                        url: "/editStockJV/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/addStockJV.tpl.html",
                        controller: "addStockJVController",
                    })

                    .state("viewStockJV", {
                        url: "/viewStockJV/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/viewStockJV.tpl.html",
                        controller: "viewStockJVController",
                    })


                    .state("StockFOC", {
                        url: "/StockFOC",
                        parent: "init",
                        templateUrl: "Templates/stock/StockFOC.tpl.html",
                        controller: "StockFOCController",
                    })

                    .state("ApprovalStockFOC", {
                        url: "/ApprovalStockFOC",
                        parent: "init",
                        templateUrl: "Templates/stock/ApprovalStockFOC.tpl.html",
                        controller: "ApprovalStockFOCController",
                    })

                    .state("addStockFOC", {
                        url: "/addStockFOC",
                        parent: "init",
                        templateUrl: "Templates/stock/addStockFOC.tpl.html",
                        controller: "addStockFOCController",
                    })

                    .state("editStockFOC", {
                        url: "/editStockFOC/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/addStockFOC.tpl.html",
                        controller: "addStockFOCController",
                    })

                    .state("viewStockFOC", {
                        url: "/viewStockFOC/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/stock/viewStockFOC.tpl.html",
                        controller: "viewStockFOCController",
                    })

                    ///////////////////////////// End Stock ///////////////////////////


                    ///////////////////////////// Documents ///////////////////////////

                    .state("voucherDocs", {
                        url: "/voucherDocs/:VoucherType/:VoucherNo/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/documents/voucherDocs.tpl.html",
                        controller: "voucherDocsController",
                    })

                    .state("voucherDocuments", {
                        url: "/voucherDocuments",
                        parent: "init",
                        templateUrl: "Templates/documents/voucherDocuments.tpl.html",
                        controller: "voucherDocumentsController",
                    })

                    .state("documentsByJobNo", {
                        url: "/documentsByJobNo",
                        parent: "init",
                        templateUrl: "Templates/documents/documentsByJobNo.tpl.html",
                        controller: "documentsByJobNoController",
                    })


                    ///////////////////////////// End Documents ///////////////////////////


                    ///////////////////////////// settings ///////////////////////////


                    .state("profile", {
                        url: "/profile",
                        parent: "init",
                        templateUrl: "Templates/profile.tpl.html",
                        controller: "profileController",
                    })
                    .state("tickets", {
                        url: "/tickets",
                        parent: "init",
                        templateUrl: "Templates/tickets.tpl.html",
                        controller: "ticketsController",
                    })
                    .state("addticket", {
                        url: "/addticket",
                        parent: "init",
                        templateUrl: "Templates/addticket.tpl.html",
                        controller: "addticketController",
                    })

                    .state("ViewTicket", {
                        parent: "init",
                        url: "/ViewTicket/:VoucherId",
                        templateUrl: "templates/ViewTicket.tpl.html",
                        controller: "ViewTicketController"
                    })


                    .state("VoucherSettings", {
                        url: "/VoucherSettings",
                        parent: "init",
                        templateUrl: "Templates/VoucherSettings.tpl.html",
                        controller: "VoucherSettingsController",
                    })

                    .state("VoucherDesign", {
                        url: "/VoucherDesign",
                        parent: "init",
                        templateUrl: "Templates/VoucherDesign.tpl.html",
                        controller: "VoucherDesignController",
                    })

                    .state("AccountLoading", {
                        url: "/AccountLoading",
                        parent: "init",
                        templateUrl: "Templates/AccountLoading.tpl.html",
                        controller: "AccountLoadingController",
                    })

                    .state("TabDesign", {
                        url: "/TabDesign",
                        parent: "init",
                        templateUrl: "Templates/TabDesign.tpl.html",
                        controller: "TabDesignController",
                    })

                    .state("ProductDesign", {
                        url: "/ProductDesign",
                        parent: "init",
                        templateUrl: "Templates/ProductDesign.tpl.html",
                        controller: "ProductDesignController",
                    })

                    .state("CustomDesign", {
                        url: "/CustomDesign",
                        parent: "init",
                        templateUrl: "Templates/CustomDesign.tpl.html",
                        controller: "CustomDesignController",
                    })

                    .state("costCenterDesign", {
                        url: "/costCenterDesign",
                        parent: "init",
                        templateUrl: "Templates/costCenterDesign.tpl.html",
                        controller: "costCenterDesignController",
                    })

                    .state("VoucherCostCenter", {
                        url: "/VoucherCostCenter",
                        parent: "init",
                        templateUrl: "Templates/VoucherCostCenter.tpl.html",
                        controller: "VoucherCostCenterController",
                    })

                    .state("VoucherLinks", {
                        url: "/VoucherLinks",
                        parent: "init",
                        templateUrl: "Templates/VoucherLinks.tpl.html",
                        controller: "VoucherLinksController",
                    })

                    .state("docNumber", {
                        url: "/docNumber",
                        parent: "init",
                        templateUrl: "Templates/docNumber.tpl.html",
                        controller: "docNumberController",
                    })



                    .state("UserPageRole", {
                        url: "/UserPageRole",
                        parent: "init",
                        templateUrl: "Templates/UserPageRole.tpl.html",
                        controller: "UserPageRoleController",
                    })

                    .state("UserRoleMapping", {
                        url: "/UserRoleMapping",
                        parent: "init",
                        templateUrl: "Templates/UserRoleMapping.tpl.html",
                        controller: "UserRoleMappingController",
                    })

                    .state("Favourites", {
                        url: "/Favourites",
                        parent: "init",
                        templateUrl: "Templates/Favourites.tpl.html",
                        controller: "FavouritesController",
                    })

                    .state("FavouriteCategories", {
                        url: "/FavouriteCategories",
                        parent: "init",
                        templateUrl: "Templates/FavouriteCategories.tpl.html",
                        controller: "FavouriteCategoriesController",
                    })

                    .state("VoucherNames", {
                        url: "/VoucherNames",
                        parent: "init",
                        templateUrl: "Templates/VoucherNames.tpl.html",
                        controller: "profileController",
                    })

                    .state("ExtraMasters", {
                        url: "/ExtraMasters",
                        parent: "init",
                        templateUrl: "Templates/ExtraMasters.tpl.html",
                        controller: "profileController",
                    })

                    .state("PrintDesign", {
                        url: "/PrintDesign",
                        parent: "init",
                        templateUrl: "Templates/PrintDesign.tpl.html",
                        controller: "PrintDesignController",
                    })

                    .state("PrintSettings", {
                        url: "/PrintSettings",
                        parent: "init",
                        templateUrl: "Templates/PrintSettings.tpl.html",
                        controller: "PrintSettingsController",
                    })

                    .state("whatsAppSettings", {
                        url: "/whatsAppSettings",
                        parent: "init",
                        templateUrl: "Templates/whatsAppSettings.tpl.html",
                        controller: "whatsAppSettingsController",
                    })

                    .state("SMSSettings", {
                        url: "/SMSSettings",
                        parent: "init",
                        templateUrl: "Templates/SMSSettings.tpl.html",
                        controller: "SMSSettingsController",
                    })

                    .state("emailTemplates", {
                        url: "/emailTemplates",
                        parent: "init",
                        templateUrl: "Templates/customization/emailTemplates.tpl.html",
                        controller: "emailTemplatesController",
                    })

                    .state("reportConfiguration", {
                        url: "/reportConfiguration",
                        parent: "init",
                        templateUrl: "Templates/reportConfiguration.tpl.html",
                        controller: "reportConfigurationController",
                    })

                      .state("productConfiguration", {
                        url: "/productConfiguration",
                        parent: "init",
                        templateUrl: "Templates/productConfiguration.tpl.html",
                        controller: "productConfigurationController",
                    })


                    .state("addPostingTemplates", {
                        url: "/addPostingTemplates",
                        parent: "init",
                        templateUrl: "Templates/customization/addPostingTemplates.tpl.html",
                        controller: "addPostingTemplatesController",
                    })

                    .state("editPostingTemplates", {
                        url: "/editPostingTemplates/:VoucherId",
                        parent: "init",
                        templateUrl: "Templates/customization/addPostingTemplates.tpl.html",
                        controller: "addPostingTemplatesController",
                    })


                    .state("postingTemplates", {
                        url: "/postingTemplates",
                        parent: "init",
                        templateUrl: "Templates/customization/postingTemplates.tpl.html",
                        controller: "postingTemplatesController",
                    })

                    .state("TableDesign", {
                        url: "/TableDesign/:VoucherType",
                        parent: "init",
                        templateUrl: "Templates/TableDesign.tpl.html",
                        controller: "TableDesignController",
                    })

                    .state("approvalConfig", {
                        url: "/approvalConfig",
                        parent: "init",
                        templateUrl: "Templates/approvalConfig.tpl.html",
                        controller: "approvalConfigController",
                    })

                    .state("ReorderTable", {
                        url: "/ReorderTable",
                        parent: "init",
                        templateUrl: "Templates/ReorderTable.tpl.html",
                        controller: "ReorderTableController",
                    })
                    .state("userMenu", {
                        url: "/userMenu",
                        parent: "init",
                        templateUrl: "Templates/settings/userMenu.tpl.html",
                        controller: "userMenuController",
                    })

                    .state("resaveVouchers", {
                        url: "/resaveVouchers",
                        parent: "init",
                        templateUrl: "Templates/resaveVouchers.tpl.html",
                        controller: "resaveVouchersController",
                    })

                    .state("reconcileVouchers", {
                        url: "/reconcileVouchers",
                        parent: "init",
                        templateUrl: "Templates/customization/reconcileVouchers.tpl.html",
                        controller: "reconcileVouchersController",
                    })

                    .state("reminders", {
                        url: "/reminders",
                        parent: "init",
                        templateUrl: "Templates/reminders.tpl.html",
                        controller: "remindersController",
                    })

                    .state("forbidden", {
                        parent: "init",
                        url: "/forbidden",
                        templateUrl: "Templates/forbidden.tpl.html",
                    })
                    .state("bulkPrint", {
                        url: "/bulkPrint",
                        parent: "init",
                        templateUrl: "Templates/bulkPrint.tpl.html",
                        controller: "bulkPrintController",
                    })


                    ///////////////////////////// end settings ///////////////////////////

                    ///////////////////////////// supports ///////////////////////////


                    .state("emailSupport", {
                        url: "/emailSupport",
                        parent: "init",
                        templateUrl: "Templates/emailSupport.tpl.html",
                    })

                    .state("enquiry", {
                        url: "/enquiry",
                        parent: "init",
                        templateUrl: "Templates/enquiry.tpl.html",
                    })

                    ///////////////////////////// end supports ///////////////////////////

                    ///////////////////////////// CRM ///////////////////////////

                    .state("lead", {
                        parent: "init",
                        url: "/lead",
                        templateUrl: "templates/crm/lead.tpl.html",
                        controller: "leadController",
                    })

                    .state("opportunity", {
                        parent: "init",
                        url: "/opportunity",
                        templateUrl: "templates/crm/opportunity.tpl.html",
                        controller: "opportunityController",
                    })

                    .state("addLead", {
                        url: "/addLead",
                        parent: "init",
                        templateUrl: "Templates/crm/addLead.tpl.html",
                        controller: "addLeadController",
                    })

                    .state("editLead", {
                        url: "/editLead/:LeadId",
                        parent: "init",
                        templateUrl: "Templates/crm/addLead.tpl.html",
                        controller: "addLeadController",
                    })

                    .state("leadType", {
                        parent: "init",
                        url: "/leadType",
                        templateUrl: "templates/crm/leadType.tpl.html",
                        controller: "leadTypeController",
                    })

                    .state("leadSource", {
                        parent: "init",
                        url: "/leadSource",
                        templateUrl: "templates/crm/leadSource.tpl.html",
                        controller: "leadSourceController",
                    })

                    ///////////////////////////// CRM ///////////////////////////

                    ///////////////////////////// Task ///////////////////////////

                    .state("taskType", {
                        parent: "init",
                        url: "/taskType",
                        templateUrl: "templates/task/taskType.tpl.html",
                        controller: "taskTypeController",
                    })
                    .state("project", {
                        parent: "init",
                        url: "/project",
                        templateUrl: "templates/task/project.tpl.html",
                        controller: "projectController",
                    })
                    .state("task", {
                        parent: "init",
                        url: "/task",
                        templateUrl: "templates/task/task.tpl.html",
                        controller: "taskController",
                    })

                    ///////////////////////////// Task ///////////////////////////

                    ///////////////////////////// Edit ///////////////////////////


                    .state("billEdit", {
                        url: "/billEdit",
                        parent: "init",
                        templateUrl: "templates/billEdit.tpl.html",
                        controller: "billEditController",
                    })

                    .state("inactiveAccounts", {
                        url: "/inactiveAccounts",
                        parent: "init",
                        templateUrl: "templates/inactiveAccounts.tpl.html",
                        controller: "inactiveAccountsController",
                    })

                    .state("missingAccounts", {
                        url: "/missingAccounts",
                        parent: "init",
                        templateUrl: "templates/missingAccounts.tpl.html",
                        controller: "missingAccountsController",
                    })

                    .state("fiFoReconcile", {
                        url: "/fiFoReconcile",
                        parent: "init",
                        templateUrl: "templates/fiFoReconcile.tpl.html",
                        controller: "fiFoReconcileController",
                    })

                    ///////////////////////////// Property ///////////////////////////


                    .state("BuildingType", {
                        url: "/BuildingType",
                        parent: "init",
                        templateUrl: "templates/property/BuildingType.tpl.html",
                        controller: "BuildingTypeController",
                    })

                    .state("Particulars", {
                        url: "/Particulars",
                        parent: "init",
                        templateUrl: "templates/property/Particulars.tpl.html",
                        controller: "ParticularsController",
                    })

                    .state("Building", {
                        url: "/Building",
                        parent: "init",
                        templateUrl: "templates/property/Building.tpl.html",
                        controller: "BuildingController",
                    })

                    .state("AddBuilding", {
                        url: "/AddBuilding",
                        parent: "init",
                        templateUrl: "templates/property/AddBuilding.tpl.html",
                        controller: "AddBuildingController",
                    })

                    .state("EditBuilding", {
                        url: "/EditBuilding/:BuildingId",
                        parent: "init",
                        templateUrl: "templates/property/AddBuilding.tpl.html",
                        controller: "AddBuildingController",
                    })

                    .state("FlatType", {
                        url: "/FlatType",
                        parent: "init",
                        templateUrl: "templates/property/FlatType.tpl.html",
                        controller: "FlatTypeController",
                    })

                    .state("Flat", {
                        url: "/Flat",
                        parent: "init",
                        templateUrl: "templates/property/Flat.tpl.html",
                        controller: "FlatController",
                    })

                    .state("AddFlat", {
                        url: "/AddFlat",
                        parent: "init",
                        templateUrl: "templates/property/AddFlat.tpl.html",
                        controller: "AddFlatController",
                    })

                    .state("EditFlat", {
                        url: "/EditFlat/:FlatId",
                        parent: "init",
                        templateUrl: "templates/property/AddFlat.tpl.html",
                        controller: "AddFlatController",
                    })

                    .state("FlatStatus", {
                        url: "/FlatStatus",
                        parent: "init",
                        templateUrl: "Templates/property/FlatStatus.tpl.html",
                        controller: "FlatStatusController",
                    })

                    .state("Parking", {
                        url: "/Parking",
                        parent: "init",
                        templateUrl: "Templates/property/Parkings.tpl.html",
                        controller: "ParkingsController",
                    })

                    .state("BuildingSummary", {
                        url: "/BuildingSummary",
                        parent: "init",
                        templateUrl: "Templates/property/BuildingSummary.tpl.html",
                        controller: "BuildingSummaryController",
                    })

                    .state("TenancyContract", {
                        url: "/TenancyContract",
                        parent: "init",
                        templateUrl: "templates/property/TenancyContract.tpl.html",
                        controller: "TenancyContractController",
                    })

                    .state("AddTenancyContract", {
                        url: "/AddTenancyContract",
                        parent: "init",
                        templateUrl: "templates/property/AddTenancyContract.tpl.html",
                        controller: "AddTenancyContractController",
                    })

                    .state("editTenancyContract", {
                        url: "/editTenancyContract/:VoucherId",
                        parent: "init",
                        templateUrl: "templates/property/AddTenancyContract.tpl.html",
                        controller: "AddTenancyContractController",
                    })

                    .state("PUTenancyContract", {
                        url: "/PUTenancyContract",
                        parent: "init",
                        templateUrl: "templates/property/PUTenancyContract.tpl.html",
                        controller: "PUTenancyContractController",
                    })

                    .state("AddPUTenancyContract", {
                        url: "/AddPUTenancyContract",
                        parent: "init",
                        templateUrl: "templates/property/AddPUTenancyContract.tpl.html",
                        controller: "AddPUTenancyContractController",
                    })

                    .state("editPUTenancyContract", {
                        url: "/editPUTenancyContract/:VoucherId",
                        parent: "init",
                        templateUrl: "templates/property/AddPUTenancyContract.tpl.html",
                        controller: "AddPUTenancyContractController",
                    })



                //
                //
                //                    .state("propertyReport", {
                //                        url: "/propertyReport",
                //                        parent: "init",
                //                        templateUrl: "templates/reports/propertyReport.tpl.html",
                //                        //                        controller: "propertyReportController",
                //                    })
                //
                //
                //                    .state("approvedContracts", {
                //                        url: "/approvedContracts",
                //                        parent: "init",
                //                        templateUrl: "templates/reports/contractsReport.tpl.html",
                //                        controller: "contractsReportController",
                //                    })
                //
                //                    .state("unapprovedContracts", {
                //                        url: "/unapprovedContracts",
                //                        parent: "init",
                //                        templateUrl: "templates/reports/contractsReport.tpl.html",
                //                        controller: "contractsReportController",
                //                    })
                //
                //                    .state("closedContracts", {
                //                        url: "/closedContracts",
                //                        parent: "init",
                //                        templateUrl: "templates/reports/contractsReport.tpl.html",
                //                        controller: "contractsReportController",
                //                    })


        }])

        .config(['localStorageServiceProvider', function (localStorageServiceProvider) {
            localStorageServiceProvider
                .setPrefix('ainapp')
                .setStorageType('localStorage')
                .setNotify(true, true);
    }])
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push("AuthInterceptor")
    }]);

})();
